<template>
  <div class="image-options-setting-dialog">
    <div v-show="activeType == 1" class="content-group-default">
      <el-collapse v-if="options.styleType === 'horizontal'" v-model="activeNames">
        <template v-if="curSub === 0">
          <el-collapse-item
            @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '2')"
            title="锚点按钮"
            name="2"
          >
            <div class="setting-item">
              <div class="subItemBox" @click="changeSubItem(1, true)">
                <span class="subItemTitle">切换项</span>
                <span class="subItemLabel fs12">配置<i class="subItemIcon icon-portal-arrows-right"></i></span>
              </div>
            </div>
          </el-collapse-item>
          <controlWidthAndSizeAndZindex :options="options" :ids="ids" />
          <el-collapse-item
            @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '4')"
            title="排列"
            name="4"
          >
            <div
              class="setting-item clearFloat"
              v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '4')"
            >
              <!-- <cx-slider label="对齐" :value.sync="alignmentType" :options="alignmentTypeOptions" :showToolTip="true" /> -->
              <div class="content-item verticallyCenter">
                <slider-and-input
                  inputWidth="small"
                  :value.sync="marginRight"
                  title="左右间距"
                  titlePosition="singleLine"
                  :sliderMax="500"
                  suffix="px"
                />
              </div>
              <div class="content-item mt12 verticallyCenter">
                <slider-and-input
                  inputWidth="small"
                  :value.sync="marginBottom"
                  title="上下间距"
                  titlePosition="singleLine"
                  :sliderMax="500"
                  suffix="px"
                />
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item
            @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '6')"
            title="背景"
            name="6"
          >
            <div class="content-item">
              <cx-background :background.sync="background" imgType="10" />
            </div>
          </el-collapse-item>
          <el-collapse-item
            @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '7')"
            title="边框"
            name="7"
          >
            <div class="content-item">
              <div class="content-item verticallyCenter mb12">
                <el-checkbox v-model="showAllBorder">显示边框</el-checkbox>
              </div>
              <cx-border
                v-if="showAllBorder"
                :borderWidth.sync="allBorderWidth"
                :borderStyle.sync="allBorderStyle"
                :borderColor.sync="allBorderColor"
                :borderIsThemeColor.sync="allBorderIsThemeColor"
              />
            </div>
            <div class="content-item mt12">
              <border-radius
                :borderTypeFlag.sync="allBorderTypeFlag"
                :borderRadius.sync="allBorderRadius"
                :borderTopLeftRadius.sync="allBorderTopLeftRadius"
                :borderTopRightRadius.sync="allBorderTopRightRadius"
                :borderBottomRightRadius.sync="allBorderBottomRightRadius"
                :borderBottomLeftRadius.sync="allBorderBottomLeftRadius"
              />
            </div>
          </el-collapse-item>
          <el-collapse-item
            @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '8')"
            title="边距"
            name="8"
          >
            <div class="content-item">
              <cx-padding
                :paddingTypeFlag.sync="ulPaddingTypeFlag"
                :padding.sync="ulPadding"
                :paddingTop.sync="ulPaddingTop"
                :paddingRight.sync="ulPaddingRight"
                :paddingBottom.sync="ulPaddingBottom"
                :paddingLeft.sync="ulPaddingLeft"
              />
            </div>
          </el-collapse-item>
          <el-collapse-item
            @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '9')"
            title="更多"
            name="9"
          >
            <div class="content" v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '9')">
              <div class="content-item">
                <slider-and-input :value.sync="opacity" title="透明度" :sliderMax="100" suffix="%" />
              </div>
              <div class="content-item mt12">
                <div class="checkbox_colorPicker_container">
                  <span>阴影</span>
                  <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow('b')"></span>
                </div>
                <box-shadow
                  :boxShadowH.sync="boxShadowH"
                  :boxShadowV.sync="boxShadowV"
                  :boxShadowBlur.sync="boxShadowBlur"
                  :boxShadowSpread.sync="boxShadowSpread"
                  :boxShadowColor.sync="boxShadowColor"
                ></box-shadow>
              </div>
              <div class="content-item verticallyCenter mt12">
                <el-checkbox class="" v-model="showAnchorScorll">开启横向滚动</el-checkbox>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item
            v-show="$store.state.states.showPluginSetting"
            @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '10')"
            title="插件"
            name="10"
          >
            <div
              class="setting-item"
              v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '10')"
            >
              <elementPluginSetting :pluginName="pluginName" :myid="ids"></elementPluginSetting>
            </div>
          </el-collapse-item>
        </template>
        <template v-if="curSub === 1">
          <div class="subBackBox" @click="changeSubItem(0, false)">
            <i class="subBackIcon icon-portal-arrows-left"></i>
            <span class="subBackTitle">切换项</span>
          </div>
          <cx-slider class="rect-active-slider" label="状态" :value.sync="statusType" :options="statusTypeOptions" />
          <!-- 默认状态 -->
          <template v-if="statusType === '1'">
            <anchorSize :options="options" :ids="ids" />
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '1')"
              title="尺寸"
              name="1"
              style="display: none"
            >
              <div class="content">
                <div class="content-item mb16 verticallyCenter">
                  <div class="verticallyCenter">
                    <span class="fs14 mr16">宽度</span>
                    <el-radio-group v-model="widthAuto">
                      <el-radio :label="true">自适应</el-radio>
                      <el-radio :label="false">固定宽度</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div class="content-item verticallyCenter">
                  <slider-and-input
                    v-if="!widthAuto"
                    :value.sync="anchorWidth"
                    titlePosition="singleLine"
                    :sliderMax="500"
                    suffix="px"
                  />
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '5')"
              title="文字"
              name="5"
            >
              <div
                class="setting-item"
                v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '5')"
              >
                <text-setting-complex-update
                  :fontFamily.sync="fontFamily"
                  :fontSize.sync="fontSize"
                  :fontWeight.sync="fontWeight"
                  :fontStyle.sync="fontStyle"
                  :textDecoration.sync="textDecoration"
                  :lineHeight.sync="lineHeight"
                  :letterSpacing.sync="letterSpacing"
                  :activeArrangement.sync="activeArrangement"
                  :writingMode.sync="writingMode"
                  :textAlign.sync="textAlign"
                  :activeArrangementOrder.sync="activeArrangementOrder"
                  :lineHeightType.sync="lineHeightType"
                  :letterSpacingType.sync="letterSpacingType"
                  :isThemeColor.sync="textIsThemeColor"
                  :colorArr.sync="color"
                  :showOverflowSetting="true"
                  :contentHasLimit.sync="contentHasLimit"
                  :contentHasLimitRadio.sync="contentHasLimitRadio"
                  :textLimitWords.sync="textLimitLines"
                  :textLimitLines.sync="textLimitWords"
                  :options="options"
                />
              </div>
            </el-collapse-item>
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '6')"
              title="背景"
              name="6"
            >
              <div class="content-item clearFloat">
                <cx-background :background.sync="defaultBackground" imgType="10" class="" />
              </div>
            </el-collapse-item>
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '7')"
              title="图标"
              name="7"
            >
              <div
                class="setting-item"
                v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '7')"
              >
                <div class="content">
                  <el-checkbox v-model="showIcon" class="">显示图标</el-checkbox>
                  <img-icon-upload
                    v-show="showIcon"
                    class="mt16"
                    :imgSrc.sync="iconSrc"
                    :iconType.sync="iconType"
                    :iconColor.sync="iconColor"
                    :showDel="false"
                    :resInfo.sync="resInfo"
                  />
                  <div v-show="showIcon" class="content-item mt16 verticallyCenter">
                    <span class="mr16 fs14">位置</span>
                    <el-radio-group v-model="iconPosition">
                      <el-radio label="left">左</el-radio>
                      <el-radio label="right">右</el-radio>
                    </el-radio-group>
                  </div>
                  <slider-and-input
                    v-show="showIcon"
                    class="mt16"
                    :value.sync="iconMargin"
                    title="间距"
                    :sliderMax="iptSliderMax"
                    suffix="px"
                  />
                  <div v-show="showIcon" class="verticallyCenter mt16 content-item">
                    <span class="mr16 fs14">颜色</span>
                    <cx-color-picker
                      class="flex1"
                      :isThemeColor.sync="iconColorIsThemeColor"
                      :colorArr.sync="iconColor"
                    >
                    </cx-color-picker>
                  </div>
                  <slider-and-input
                    v-show="showIcon"
                    class="mt16"
                    :value.sync="iconWidth"
                    title="宽度"
                    :sliderMax="iptSliderMax"
                    suffix="px"
                  />
                  <slider-and-input
                    v-show="showIcon"
                    class="mt16"
                    :value.sync="iconHeight"
                    title="高度"
                    :sliderMax="iptSliderMax"
                    suffix="px"
                  />
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item title="分隔符" name="9">
              <el-checkbox v-model="showDivide">显示分隔符</el-checkbox>
              <div class="content-item mt12" v-if="showDivide">
                <cx-slider label="类型" :value.sync="divideType" :options="divideTypeOptions" />
                <div class="mt12" v-if="divideType === 'custom'">
                  <img-icon-upload
                    :imgSrc.sync="divideIconSrc"
                    :iconType.sync="divideIconType"
                    :iconColor.sync="divideIconColor"
                    :resInfo.sync="divideResInfo"
                  />
                  <div class="verticallyCenter mt12" v-if="divideIconType !== 'img'">
                    <span class="mr16 fs14">颜色</span>
                    <cx-color-picker
                      class="flex1"
                      :isThemeColor.sync="divideIconColorIsThemeColor"
                      :colorArr.sync="divideIconColor"
                    >
                    </cx-color-picker>
                  </div>
                </div>
                <div class="mt12" v-else>
                  <div class="verticallyCenter">
                    <span class="mr16 fs14">颜色</span>
                    <cx-color-picker
                      class="flex1"
                      :isThemeColor.sync="divideIconColorIsThemeColor"
                      :colorArr.sync="divideIconColor"
                    >
                    </cx-color-picker>
                  </div>
                </div>
                <div class="verticallyCenter mt12">
                  <span class="mr16 fs14">尺寸</span>
                  <div class="verticallyCenter mr16 flex1">
                    <single-input
                      class="input-size"
                      placeholder="-"
                      :value.sync="divideWidth"
                      :min="1"
                      inputSuffixs="宽"
                    />
                  </div>
                  <div class="verticallyCenter flex1">
                    <single-input
                      class="input-size"
                      placeholder="-"
                      :value.sync="divideHeight"
                      :min="1"
                      inputSuffixs="高"
                    />
                  </div>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '10')"
              title="边框"
              name="10"
            >
              <div class="content-item">
                <div class="content-item verticallyCenter mb12">
                  <el-checkbox v-model="showBorder">显示边框</el-checkbox>
                </div>
                <cx-border
                  v-if="showBorder"
                  :borderWidth.sync="borderWidth"
                  :borderStyle.sync="borderStyle"
                  :borderColor.sync="borderColor"
                  :borderIsThemeColor.sync="borderIsThemeColor"
                />
              </div>
              <div class="content-item mt12">
                <border-radius
                  :borderTypeFlag.sync="borderTypeFlag"
                  :borderRadius.sync="borderRadius"
                  :borderTopLeftRadius.sync="borderTopLeftRadius"
                  :borderTopRightRadius.sync="borderTopRightRadius"
                  :borderBottomRightRadius.sync="borderBottomRightRadius"
                  :borderBottomLeftRadius.sync="borderBottomLeftRadius"
                />
              </div>
            </el-collapse-item>
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '11')"
              title="边距"
              name="11"
            >
              <div class="content-item clearFloat">
                <cx-padding
                  :paddingTypeFlag.sync="paddingTypeFlag"
                  :padding.sync="padding"
                  :paddingTop.sync="paddingTop"
                  :paddingRight.sync="paddingRight"
                  :paddingBottom.sync="paddingBottom"
                  :paddingLeft.sync="paddingLeft"
                />
              </div>
            </el-collapse-item>
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '12')"
              title="更多"
              name="12"
            >
              <div class="content-item">
                <slider-and-input :value.sync="anchorOpacity" title="透明度" :sliderMax="100" suffix="%" />
              </div>
              <div class="content-item mt12">
                <div class="checkbox_colorPicker_container">
                  <span>阴影</span>
                  <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow('defaultB')"></span>
                </div>
                <box-shadow
                  :boxShadowH.sync="defaultBoxShadowH"
                  :boxShadowV.sync="defaultBoxShadowV"
                  :boxShadowBlur.sync="defaultBoxShadowBlur"
                  :boxShadowSpread.sync="defaultBoxShadowSpread"
                  :boxShadowColor.sync="defaultBoxShadowColor"
                ></box-shadow>
              </div>
            </el-collapse-item>
          </template>
          <!-- 选中状态 -->
          <template v-if="statusType === '2'">
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '5')"
              title="文字"
              name="5"
            >
              <div
                class="setting-item"
                v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '5')"
              >
                <div class="content">
                  <text-setting-complex-update
                    :fontFamily.sync="activeFontFamily"
                    :fontSize.sync="activeFontSize"
                    :fontWeight.sync="activeFontWeight"
                    :fontStyle.sync="activeFontStyle"
                    :textDecoration.sync="activeTextDecoration"
                    :lineHeight.sync="activeLineHeight"
                    :letterSpacing.sync="activeLetterSpacing"
                    :activeArrangement.sync="activeActiveArrangement"
                    :writingMode.sync="activeWritingMode"
                    :textAlign.sync="activeTextAlign"
                    :activeArrangementOrder.sync="activeActiveArrangementOrder"
                    :lineHeightType.sync="activeLineHeightType"
                    :letterSpacingType.sync="activeLetterSpacingType"
                    :isThemeColor.sync="activeTextIsThemeColor"
                    :colorArr.sync="activeColor"
                    :options="options"
                  />
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '6')"
              title="背景"
              name="6"
            >
              <div class="content-item clearFloat">
                <cx-background :background.sync="activeBackground" imgType="10" class="" />
              </div>
            </el-collapse-item>
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '7')"
              title="边框"
              name="7"
            >
              <div class="content-item">
                <div class="content-item verticallyCenter mb12">
                  <el-checkbox v-model="showActiveBorder">显示边框</el-checkbox>
                </div>
                <cx-border
                  v-if="showActiveBorder"
                  :borderWidth.sync="activeBorderWidth"
                  :borderStyle.sync="activeBorderStyle"
                  :borderColor.sync="activeBorderColor"
                  :borderIsThemeColor.sync="activeBorderIsThemeColor"
                />
              </div>
              <div class="content-item mt12">
                <border-radius
                  :borderTypeFlag.sync="activeBorderTypeFlag"
                  :borderRadius.sync="activeBorderRadius"
                  :borderTopLeftRadius.sync="activeBorderTopLeftRadius"
                  :borderTopRightRadius.sync="activeBorderTopRightRadius"
                  :borderBottomRightRadius.sync="activeBorderBottomRightRadius"
                  :borderBottomLeftRadius.sync="activeBorderBottomLeftRadius"
                />
              </div>
            </el-collapse-item>
          </template>
          <!-- 悬浮状态 -->
          <template v-if="statusType === '3'">
            <el-checkbox class="paddingl15 mb12 mt8" v-model="hoverIsSameActive">同选中状态</el-checkbox>
            <div v-if="!hoverIsSameActive">
              <el-collapse-item
                @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '5')"
                title="文字"
                name="5"
              >
                <div
                  class="setting-item"
                  v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '5')"
                >
                  <div class="content">
                    <text-setting-complex-update
                      :fontFamily.sync="hoverFontFamily"
                      :fontSize.sync="hoverFontSize"
                      :fontWeight.sync="hoverFontWeight"
                      :fontStyle.sync="hoverFontStyle"
                      :textDecoration.sync="hoverTextDecoration"
                      :lineHeight.sync="hoverLineHeight"
                      :letterSpacing.sync="hoverLetterSpacing"
                      :activeArrangement.sync="hoverArrangement"
                      :writingMode.sync="hoverWritingMode"
                      :textAlign.sync="hoverTextAlign"
                      :activeArrangementOrder.sync="hoverArrangementOrder"
                      :lineHeightType.sync="hoverLineHeightType"
                      :letterSpacingType.sync="hoverLetterSpacingType"
                      :isThemeColor.sync="hoverTextIsThemeColor"
                      :colorArr.sync="hoverColor"
                    />
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item
                @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '6')"
                title="背景"
                name="6"
              >
                <div class="content-item clearFloat">
                  <cx-background :background.sync="hoverBackground" imgType="10" class="" />
                </div>
              </el-collapse-item>
              <el-collapse-item
                @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '7')"
                title="边框"
                name="7"
              >
                <div class="content-item">
                  <div class="content-item verticallyCenter mb12">
                    <el-checkbox v-model="showHoverBorder">显示边框</el-checkbox>
                  </div>
                  <cx-border
                    v-if="showHoverBorder"
                    :borderWidth.sync="hoverBorderWidth"
                    :borderStyle.sync="hoverBorderStyle"
                    :borderColor.sync="hoverBorderColor"
                    :borderIsThemeColor.sync="hoverBorderIsThemeColor"
                  />
                </div>
                <div class="content-item mt12">
                  <border-radius
                    :borderTypeFlag.sync="hoverBorderTypeFlag"
                    :borderRadius.sync="hoverBorderRadius"
                    :borderTopLeftRadius.sync="hoverBorderTopLeftRadius"
                    :borderTopRightRadius.sync="hoverBorderTopRightRadius"
                    :borderBottomRightRadius.sync="hoverBorderBottomRightRadius"
                    :borderBottomLeftRadius.sync="hoverBorderBottomLeftRadius"
                  />
                </div>
              </el-collapse-item>
            </div>
          </template>
        </template>
      </el-collapse>
      <el-collapse v-else v-model="activeNames">
        <template v-if="curSub === 0">
          <el-collapse-item
            @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '2')"
            title="锚点导航"
            name="2"
          >
            <div class="setting-item">
              <div class="subItemBox" @click="changeSubItem(1, true)">
                <span class="subItemTitle">一级锚点</span>
                <span class="subItemLabel fs12">配置<i class="subItemIcon icon-portal-arrows-right"></i></span>
              </div>
              <div class="subItemBox mt8" @click="changeSubItem(2, true)">
                <span class="subItemTitle">次级锚点</span>
                <span class="subItemLabel fs12">配置<i class="subItemIcon icon-portal-arrows-right"></i></span>
              </div>
            </div>
          </el-collapse-item>
          <controlWidthAndSizeAndZindex :options="options" :ids="ids" />
          <el-collapse-item
            @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '6')"
            title="背景"
            name="6"
          >
            <div class="content-item">
              <cx-background :background.sync="background" imgType="10" />
            </div>
          </el-collapse-item>
          <el-collapse-item
            @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '7')"
            title="边框"
            name="7"
          >
            <div class="content-item">
              <div class="content-item verticallyCenter mb12">
                <el-checkbox v-model="showAllBorder">显示边框</el-checkbox>
              </div>
              <cx-border
                v-if="showAllBorder"
                :borderWidth.sync="allBorderWidth"
                :borderStyle.sync="allBorderStyle"
                :borderColor.sync="allBorderColor"
                :borderIsThemeColor.sync="allBorderIsThemeColor"
              />
            </div>
            <div class="content-item mt12">
              <border-radius
                :borderTypeFlag.sync="allBorderTypeFlag"
                :borderRadius.sync="allBorderRadius"
                :borderTopLeftRadius.sync="allBorderTopLeftRadius"
                :borderTopRightRadius.sync="allBorderTopRightRadius"
                :borderBottomRightRadius.sync="allBorderBottomRightRadius"
                :borderBottomLeftRadius.sync="allBorderBottomLeftRadius"
              />
            </div>
          </el-collapse-item>
          <el-collapse-item
            @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '8')"
            title="边距"
            name="8"
          >
            <div class="content-item">
              <cx-padding
                :paddingTypeFlag.sync="ulPaddingTypeFlag"
                :padding.sync="ulPadding"
                :paddingTop.sync="ulPaddingTop"
                :paddingRight.sync="ulPaddingRight"
                :paddingBottom.sync="ulPaddingBottom"
                :paddingLeft.sync="ulPaddingLeft"
              />
            </div>
          </el-collapse-item>
          <el-collapse-item
            @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '9')"
            title="更多"
            name="9"
          >
            <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '9')">
              <div class="content">
                <div>
                  <slider-and-input
                    inputWidth="small"
                    inputHeight="small"
                    :value.sync="indent"
                    title="缩进"
                    :sliderMax="50"
                    suffix="px"
                  />
                </div>
                <div class="verticallyCenter mt16">
                  <slider-and-input
                    inputWidth="small"
                    inputHeight="small"
                    :value.sync="opacity"
                    title="透明度"
                    :sliderMax="100"
                    suffix="%"
                  />
                </div>
                <div class="content-item mt16">
                  <div class="checkbox_colorPicker_container">
                    <span>阴影</span>
                    <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow('b')"></span>
                  </div>
                  <box-shadow
                    :boxShadowH.sync="boxShadowH"
                    :boxShadowV.sync="boxShadowV"
                    :boxShadowBlur.sync="boxShadowBlur"
                    :boxShadowSpread.sync="boxShadowSpread"
                    :boxShadowColor.sync="boxShadowColor"
                  />
                </div>
                <cx-check-box v-if="!fullScrollAnchor" :value.sync="noteEditorAnchor" class="mt16"
                  >笔记编辑器锚点</cx-check-box
                >
                <cx-check-box
                  v-if="pageEnableFullScroll && !noteEditorAnchor"
                  :value.sync="fullScrollAnchor"
                  class="mt12"
                  >整屏切换锚点</cx-check-box
                >
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item
            v-show="$store.state.states.showPluginSetting"
            @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '10')"
            title="插件"
            name="10"
          >
            <div
              class="setting-item"
              v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '10')"
            >
              <elementPluginSetting :pluginName="pluginName" :myid="ids"></elementPluginSetting>
            </div>
          </el-collapse-item>
        </template>
        <template v-if="curSub === 1">
          <div class="subBackBox" @click="changeSubItem(0, false)">
            <i class="subBackIcon icon-portal-arrows-left"></i>
            <span class="subBackTitle">一级锚点</span>
          </div>
          <cx-slider class="rect-active-slider" label="状态" :value.sync="statusType" :options="statusTypeOptions" />
          <!-- 默认状态 -->
          <template v-if="statusType === '1'">
            <anchorSize :options="options" :ids="ids" />
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '1')"
              title="尺寸"
              name="1"
              style="display: none"
            >
              <div class="content">
                <div class="content-item mb16 verticallyCenter">
                  <div class="verticallyCenter">
                    <span class="fs14 mr16">宽度</span>
                    <el-radio-group v-model="widthAuto">
                      <el-radio :label="true">自适应</el-radio>
                      <el-radio :label="false">固定宽度</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div class="content-item verticallyCenter">
                  <slider-and-input
                    v-if="!widthAuto"
                    :value.sync="anchorWidth"
                    titlePosition="singleLine"
                    :sliderMax="500"
                    suffix="px"
                  />
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '5')"
              title="文字"
              name="5"
            >
              <div
                class="setting-item"
                v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '5')"
              >
                <text-setting-complex-update
                  :fontFamily.sync="fontFamily"
                  :fontSize.sync="fontSize"
                  :fontWeight.sync="fontWeight"
                  :fontStyle.sync="fontStyle"
                  :textDecoration.sync="textDecoration"
                  :lineHeight.sync="lineHeight"
                  :letterSpacing.sync="letterSpacing"
                  :activeArrangement.sync="activeArrangement"
                  :writingMode.sync="writingMode"
                  :textAlign.sync="textAlign"
                  :activeArrangementOrder.sync="activeArrangementOrder"
                  :lineHeightType.sync="lineHeightType"
                  :letterSpacingType.sync="letterSpacingType"
                  :isThemeColor.sync="textIsThemeColor"
                  :colorArr.sync="color"
                  :showOverflowSetting="true"
                  :contentHasLimit.sync="contentHasLimit"
                  :contentHasLimitRadio.sync="contentHasLimitRadio"
                  :textLimitWords.sync="textLimitLines"
                  :textLimitLines.sync="textLimitWords"
                  :options="options"
                />
              </div>
            </el-collapse-item>
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '6')"
              title="背景"
              name="6"
            >
              <div class="content-item clearFloat">
                <cx-background :background.sync="defaultBackground" imgType="10" class="" />
              </div>
            </el-collapse-item>
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '7')"
              title="图标"
              name="7"
            >
              <div
                class="setting-item"
                v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '7')"
              >
                <div class="content">
                  <el-checkbox v-model="showIcon" class="">显示图标</el-checkbox>
                  <img-icon-upload
                    v-show="showIcon"
                    class="mt16"
                    :imgSrc.sync="iconSrc"
                    :iconType.sync="iconType"
                    :iconColor.sync="iconColor"
                    :showDel="false"
                    :resInfo.sync="resInfo"
                  />
                  <div v-show="showIcon" class="content-item mt16 verticallyCenter">
                    <span class="mr16 fs14">位置</span>
                    <el-radio-group v-model="iconPosition">
                      <el-radio label="left">左</el-radio>
                      <el-radio label="right">右</el-radio>
                    </el-radio-group>
                  </div>
                  <slider-and-input
                    v-show="showIcon"
                    class="mt16"
                    :value.sync="iconMargin"
                    title="间距"
                    :sliderMax="iptSliderMax"
                    suffix="px"
                  />
                  <div v-show="showIcon" class="verticallyCenter mt16 content-item">
                    <span class="mr16 fs14">颜色</span>
                    <cx-color-picker
                      class="flex1"
                      :isThemeColor.sync="iconColorIsThemeColor"
                      :colorArr.sync="iconColor"
                    >
                    </cx-color-picker>
                  </div>
                  <slider-and-input
                    v-show="showIcon"
                    class="mt16"
                    :value.sync="iconWidth"
                    title="宽度"
                    :sliderMax="iptSliderMax"
                    suffix="px"
                  />
                  <slider-and-input
                    v-show="showIcon"
                    class="mt16"
                    :value.sync="iconHeight"
                    title="高度"
                    :sliderMax="iptSliderMax"
                    suffix="px"
                  />
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '8')"
              title="边框"
              name="8"
            >
              <div class="content-item">
                <div class="content-item verticallyCenter mb12">
                  <el-checkbox v-model="showBorder">显示边框</el-checkbox>
                </div>
                <cx-border
                  v-if="showBorder"
                  :borderWidth.sync="borderWidth"
                  :borderStyle.sync="borderStyle"
                  :borderColor.sync="borderColor"
                  :borderIsThemeColor.sync="borderIsThemeColor"
                />
              </div>
              <div class="content-item mt12">
                <border-radius
                  :borderTypeFlag.sync="borderTypeFlag"
                  :borderRadius.sync="borderRadius"
                  :borderTopLeftRadius.sync="borderTopLeftRadius"
                  :borderTopRightRadius.sync="borderTopRightRadius"
                  :borderBottomRightRadius.sync="borderBottomRightRadius"
                  :borderBottomLeftRadius.sync="borderBottomLeftRadius"
                />
              </div>
            </el-collapse-item>
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '9')"
              title="边距"
              name="9"
            >
              <div class="content-item clearFloat">
                <cx-padding
                  :paddingTypeFlag.sync="paddingTypeFlag"
                  :padding.sync="padding"
                  :paddingTop.sync="paddingTop"
                  :paddingRight.sync="paddingRight"
                  :paddingBottom.sync="paddingBottom"
                  :paddingLeft.sync="paddingLeft"
                />
              </div>
            </el-collapse-item>
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '10')"
              title="更多"
              name="10"
            >
              <div class="content-item">
                <slider-and-input :value.sync="anchorOpacity" title="透明度" :sliderMax="100" suffix="%" />
              </div>
              <div class="content-item mt12">
                <div class="checkbox_colorPicker_container">
                  <span>阴影</span>
                  <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow('defaultB')"></span>
                </div>
                <box-shadow
                  :boxShadowH.sync="defaultBoxShadowH"
                  :boxShadowV.sync="defaultBoxShadowV"
                  :boxShadowBlur.sync="defaultBoxShadowBlur"
                  :boxShadowSpread.sync="defaultBoxShadowSpread"
                  :boxShadowColor.sync="defaultBoxShadowColor"
                ></box-shadow>
              </div>
            </el-collapse-item>
          </template>
          <!-- 选中状态 -->
          <template v-if="statusType === '2'">
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '5')"
              title="文字"
              name="5"
            >
              <div
                class="setting-item"
                v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '5')"
              >
                <div class="content">
                  <text-setting-complex-update
                    :fontFamily.sync="activeFontFamily"
                    :fontSize.sync="activeFontSize"
                    :fontWeight.sync="activeFontWeight"
                    :fontStyle.sync="activeFontStyle"
                    :textDecoration.sync="activeTextDecoration"
                    :lineHeight.sync="activeLineHeight"
                    :letterSpacing.sync="activeLetterSpacing"
                    :activeArrangement.sync="activeActiveArrangement"
                    :writingMode.sync="activeWritingMode"
                    :textAlign.sync="activeTextAlign"
                    :activeArrangementOrder.sync="activeActiveArrangementOrder"
                    :lineHeightType.sync="activeLineHeightType"
                    :letterSpacingType.sync="activeLetterSpacingType"
                    :isThemeColor.sync="activeTextIsThemeColor"
                    :colorArr.sync="activeColor"
                    :options="options"
                  />
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '6')"
              title="背景"
              name="6"
            >
              <div class="content-item clearFloat">
                <cx-background :background.sync="activeBackground" imgType="10" />
              </div>
            </el-collapse-item>
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '7')"
              title="图标"
              name="7"
            >
              <div
                class="setting-item"
                v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '7')"
              >
                <div class="content">
                  <el-checkbox v-model="activeShowIcon">显示图标</el-checkbox>
                  <div v-show="activeShowIcon">
                    <img-icon-upload
                      class="mt16"
                      :imgSrc.sync="activeIconSrc"
                      :iconType.sync="activeIconType"
                      :iconColor.sync="activeIconColor"
                      :showDel="false"
                      :resInfo.sync="activeResInfo"
                    />
                    <div class="content-item mt16 verticallyCenter">
                      <span class="mr16 fs14">位置</span>
                      <el-radio-group v-model="activeIconPosition">
                        <el-radio label="left">左</el-radio>
                        <el-radio label="right">右</el-radio>
                      </el-radio-group>
                    </div>
                    <slider-and-input
                      class="mt16"
                      :value.sync="activeIconMargin"
                      title="间距"
                      :sliderMax="iptSliderMax"
                      suffix="px"
                    />
                    <div class="verticallyCenter mt16 content-item">
                      <span class="mr16 fs14">颜色</span>
                      <cx-color-picker
                        class="flex1"
                        :isThemeColor.sync="activeIconColorIsThemeColor"
                        :colorArr.sync="activeIconColor"
                      >
                      </cx-color-picker>
                    </div>
                    <slider-and-input
                      class="mt16"
                      :value.sync="activeIconWidth"
                      title="宽度"
                      :sliderMax="iptSliderMax"
                      suffix="px"
                    />
                    <slider-and-input
                      class="mt16"
                      :value.sync="activeIconHeight"
                      title="高度"
                      :sliderMax="iptSliderMax"
                      suffix="px"
                    />
                  </div>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '8')"
              title="边框"
              name="8"
            >
              <div class="content-item">
                <div class="content-item verticallyCenter mb12">
                  <el-checkbox v-model="showActiveBorder">显示边框</el-checkbox>
                </div>
                <cx-border
                  v-if="showActiveBorder"
                  :borderWidth.sync="activeBorderWidth"
                  :borderStyle.sync="activeBorderStyle"
                  :borderColor.sync="activeBorderColor"
                  :borderIsThemeColor.sync="activeBorderIsThemeColor"
                />
              </div>
              <div class="content-item mt12">
                <border-radius
                  :borderTypeFlag.sync="activeBorderTypeFlag"
                  :borderRadius.sync="activeBorderRadius"
                  :borderTopLeftRadius.sync="activeBorderTopLeftRadius"
                  :borderTopRightRadius.sync="activeBorderTopRightRadius"
                  :borderBottomRightRadius.sync="activeBorderBottomRightRadius"
                  :borderBottomLeftRadius.sync="activeBorderBottomLeftRadius"
                />
              </div>
            </el-collapse-item>
          </template>
          <!-- 悬浮状态 -->
          <template v-if="statusType === '3'">
            <el-checkbox class="paddingl15 mb12 mt8" v-model="hoverIsSameActive">同选中状态</el-checkbox>
            <div v-if="!hoverIsSameActive">
              <el-collapse-item
                @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '5')"
                title="文字"
                name="5"
              >
                <div
                  class="setting-item"
                  v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '5')"
                >
                  <div class="content">
                    <text-setting-complex-update
                      :fontFamily.sync="hoverFontFamily"
                      :fontSize.sync="hoverFontSize"
                      :fontWeight.sync="hoverFontWeight"
                      :fontStyle.sync="hoverFontStyle"
                      :textDecoration.sync="hoverTextDecoration"
                      :lineHeight.sync="hoverLineHeight"
                      :letterSpacing.sync="hoverLetterSpacing"
                      :activeArrangement.sync="hoverArrangement"
                      :writingMode.sync="hoverWritingMode"
                      :textAlign.sync="hoverTextAlign"
                      :activeArrangementOrder.sync="hoverArrangementOrder"
                      :lineHeightType.sync="hoverLineHeightType"
                      :letterSpacingType.sync="hoverLetterSpacingType"
                      :isThemeColor.sync="hoverTextIsThemeColor"
                      :colorArr.sync="hoverColor"
                    />
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item
                @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '6')"
                title="背景"
                name="6"
              >
                <div class="content-item clearFloat">
                  <cx-background :background.sync="hoverBackground" imgType="10" class="" />
                </div>
              </el-collapse-item>
              <el-collapse-item
                @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '8')"
                title="边框"
                name="8"
              >
                <div class="content-item">
                  <div class="content-item verticallyCenter mb12">
                    <el-checkbox v-model="showHoverBorder">显示边框</el-checkbox>
                  </div>
                  <cx-border
                    v-if="showHoverBorder"
                    :borderWidth.sync="hoverBorderWidth"
                    :borderStyle.sync="hoverBorderStyle"
                    :borderColor.sync="hoverBorderColor"
                    :borderIsThemeColor.sync="hoverBorderIsThemeColor"
                  />
                </div>
                <div class="content-item mt12">
                  <border-radius
                    :borderTypeFlag.sync="hoverBorderTypeFlag"
                    :borderRadius.sync="hoverBorderRadius"
                    :borderTopLeftRadius.sync="hoverBorderTopLeftRadius"
                    :borderTopRightRadius.sync="hoverBorderTopRightRadius"
                    :borderBottomRightRadius.sync="hoverBorderBottomRightRadius"
                    :borderBottomLeftRadius.sync="hoverBorderBottomLeftRadius"
                  />
                </div>
              </el-collapse-item>
            </div>
          </template>
        </template>
        <template v-if="curSub === 2">
          <div class="subBackBox" @click="changeSubItem(0, false)">
            <i class="subBackIcon icon-portal-arrows-left"></i>
            <span class="subBackTitle">次级锚点</span>
          </div>
          <cx-slider class="rect-active-slider" label="状态" :value.sync="statusType" :options="statusTypeOptions" />
          <!-- 默认状态 -->
          <template v-if="statusType === '1'">
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '5')"
              title="文字"
              name="5"
            >
              <div
                class="setting-item"
                v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '5')"
              >
                <text-setting-complex-update
                  :fontFamily.sync="liFontFamily"
                  :fontSize.sync="liFontSize"
                  :fontWeight.sync="liFontWeight"
                  :fontStyle.sync="liFontStyle"
                  :textDecoration.sync="liTextDecoration"
                  :lineHeight.sync="liLineHeight"
                  :letterSpacing.sync="liLetterSpacing"
                  :activeArrangement.sync="liActiveArrangement"
                  :writingMode.sync="liWritingMode"
                  :textAlign.sync="liTextAlign"
                  :activeArrangementOrder.sync="liActiveArrangementOrder"
                  :lineHeightType.sync="liLineHeightType"
                  :letterSpacingType.sync="liLetterSpacingType"
                  :isThemeColor.sync="liTextIsThemeColor"
                  :colorArr.sync="liFontColor"
                  :showOverflowSetting="true"
                  :contentHasLimit.sync="liContentHasLimit"
                  :contentHasLimitRadio.sync="liContentHasLimitRadio"
                  :textLimitWords.sync="liTextLimitLines"
                  :textLimitLines.sync="liTextLimitWords"
                  :options="options"
                />
              </div>
            </el-collapse-item>
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '6')"
              title="背景"
              name="6"
            >
              <div class="content-item clearFloat">
                <cx-background :background.sync="liBgColor" imgType="10" class="" />
              </div>
            </el-collapse-item>
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '7')"
              title="图标"
              name="7"
            >
              <div
                class="setting-item"
                v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '7')"
              >
                <div class="content">
                  <el-checkbox v-model="liShowIcon" class="">显示图标</el-checkbox>
                  <img-icon-upload
                    v-show="liShowIcon"
                    class="mt16"
                    :imgSrc.sync="liIconSrc"
                    :iconType.sync="liIconType"
                    :iconColor.sync="liIconColor"
                    :showDel="false"
                    :resInfo.sync="liResInfo"
                  />
                  <div v-show="liShowIcon" class="content-item mt16 verticallyCenter">
                    <span class="mr16 fs14">位置</span>
                    <el-radio-group v-model="liIconPosition">
                      <el-radio label="left">左</el-radio>
                      <el-radio label="right">右</el-radio>
                    </el-radio-group>
                  </div>
                  <slider-and-input
                    v-show="liShowIcon"
                    class="mt16"
                    :value.sync="liIconMargin"
                    title="间距"
                    :sliderMax="iptSliderMax"
                    suffix="px"
                  />
                  <div v-show="liShowIcon" class="verticallyCenter mt16 content-item">
                    <span class="mr16 fs14">颜色</span>
                    <cx-color-picker
                      class="flex1"
                      :isThemeColor.sync="liIconColorIsThemeColor"
                      :colorArr.sync="liIconColor"
                    >
                    </cx-color-picker>
                  </div>
                  <slider-and-input
                    v-show="liShowIcon"
                    class="mt16"
                    :value.sync="liIconWidth"
                    title="宽度"
                    :sliderMax="iptSliderMax"
                    suffix="px"
                  />
                  <slider-and-input
                    v-show="liShowIcon"
                    class="mt16"
                    :value.sync="liIconHeight"
                    title="高度"
                    :sliderMax="iptSliderMax"
                    suffix="px"
                  />
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '8')"
              title="边框"
              name="8"
            >
              <div class="content-item">
                <div class="content-item verticallyCenter mb12">
                  <el-checkbox v-model="liShowBorder">显示边框</el-checkbox>
                </div>
                <cx-border
                  v-if="liShowBorder"
                  :borderWidth.sync="liBorderWidth"
                  :borderStyle.sync="liBorderStyle"
                  :borderColor.sync="liBorderColor"
                  :borderIsThemeColor.sync="liBorderIsThemeColor"
                />
              </div>
              <div class="content-item mt12">
                <border-radius
                  :borderTypeFlag.sync="liBorderTypeFlag"
                  :borderRadius.sync="liBorderRadius"
                  :borderTopLeftRadius.sync="liBorderTopLeftRadius"
                  :borderTopRightRadius.sync="liBorderTopRightRadius"
                  :borderBottomRightRadius.sync="liBorderBottomRightRadius"
                  :borderBottomLeftRadius.sync="liBorderBottomLeftRadius"
                />
              </div>
            </el-collapse-item>
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '9')"
              title="边距"
              name="9"
            >
              <div class="content-item clearFloat">
                <cx-padding
                  :paddingTypeFlag.sync="liPaddingTypeFlag"
                  :padding.sync="liPadding"
                  :paddingTop.sync="liPaddingTop"
                  :paddingRight.sync="liPaddingRight"
                  :paddingBottom.sync="liPaddingBottom"
                  :paddingLeft.sync="liPaddingLeft"
                />
              </div>
            </el-collapse-item>
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '10')"
              title="更多"
              name="10"
            >
              <div class="content-item">
                <slider-and-input :value.sync="liOpacity" title="透明度" :sliderMax="100" suffix="%" />
              </div>
              <div class="content-item mt12">
                <div class="checkbox_colorPicker_container">
                  <span>阴影</span>
                  <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow('liB')"></span>
                </div>
                <box-shadow
                  :boxShadowH.sync="liBoxShadowH"
                  :boxShadowV.sync="liBoxShadowV"
                  :boxShadowBlur.sync="liBoxShadowBlur"
                  :boxShadowSpread.sync="liBoxShadowSpread"
                  :boxShadowColor.sync="liBoxShadowColor"
                ></box-shadow>
              </div>
            </el-collapse-item>
          </template>
          <!-- 选中状态 -->
          <template v-if="statusType === '2'">
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '5')"
              title="文字"
              name="5"
            >
              <div
                class="setting-item"
                v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '5')"
              >
                <div class="content">
                  <text-setting-complex-update
                    :fontFamily.sync="liActiveFontFamily"
                    :fontSize.sync="liActiveFontSize"
                    :fontWeight.sync="liActiveFontWeight"
                    :fontStyle.sync="liActiveFontStyle"
                    :textDecoration.sync="liActiveTextDecoration"
                    :lineHeight.sync="liActiveLineHeight"
                    :letterSpacing.sync="liActiveLetterSpacing"
                    :activeArrangement.sync="liActiveActiveArrangement"
                    :writingMode.sync="liActiveWritingMode"
                    :textAlign.sync="liActiveTextAlign"
                    :activeArrangementOrder.sync="liActiveActiveArrangementOrder"
                    :lineHeightType.sync="liActiveLineHeightType"
                    :letterSpacingType.sync="liActiveLetterSpacingType"
                    :isThemeColor.sync="liActiveTextIsThemeColor"
                    :colorArr.sync="liActiveFontColor"
                    :options="options"
                  />
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '6')"
              title="背景"
              name="6"
            >
              <div class="content-item clearFloat">
                <cx-background :background.sync="liActiveBgColor" imgType="10" />
              </div>
            </el-collapse-item>
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '7')"
              title="图标"
              name="7"
            >
              <div
                class="setting-item"
                v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '7')"
              >
                <div class="content">
                  <el-checkbox v-model="liActiveShowIcon">显示图标</el-checkbox>
                  <div v-show="liActiveShowIcon">
                    <img-icon-upload
                      class="mt16"
                      :imgSrc.sync="liActiveIconSrc"
                      :iconType.sync="liActiveIconType"
                      :iconColor.sync="liActiveIconColor"
                      :showDel="false"
                      :resInfo.sync="liActiveResInfo"
                    />
                    <div class="content-item mt16 verticallyCenter">
                      <span class="mr16 fs14">位置</span>
                      <el-radio-group v-model="liActiveIconPosition">
                        <el-radio label="left">左</el-radio>
                        <el-radio label="right">右</el-radio>
                      </el-radio-group>
                    </div>
                    <slider-and-input
                      class="mt16"
                      :value.sync="liActiveIconMargin"
                      title="间距"
                      :sliderMax="iptSliderMax"
                      suffix="px"
                    />
                    <div class="verticallyCenter mt16 content-item">
                      <span class="mr16 fs14">颜色</span>
                      <cx-color-picker
                        class="flex1"
                        :isThemeColor.sync="liActiveIconColorIsThemeColor"
                        :colorArr.sync="liActiveIconColor"
                      >
                      </cx-color-picker>
                    </div>
                    <slider-and-input
                      class="mt16"
                      :value.sync="liActiveIconWidth"
                      title="宽度"
                      :sliderMax="iptSliderMax"
                      suffix="px"
                    />
                    <slider-and-input
                      class="mt16"
                      :value.sync="liActiveIconHeight"
                      title="高度"
                      :sliderMax="iptSliderMax"
                      suffix="px"
                    />
                  </div>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '8')"
              title="边框"
              name="8"
            >
              <div class="content-item">
                <div class="content-item verticallyCenter mb12">
                  <el-checkbox v-model="liActiveShowBorder">显示边框</el-checkbox>
                </div>
                <cx-border
                  v-if="liActiveShowBorder"
                  :borderWidth.sync="liActiveBorderWidth"
                  :borderStyle.sync="liActiveBorderStyle"
                  :borderColor.sync="liActiveBorderColor"
                  :borderIsThemeColor.sync="liActiveBorderIsThemeColor"
                />
              </div>
              <div class="content-item mt12">
                <border-radius
                  :borderTypeFlag.sync="liActiveBorderTypeFlag"
                  :borderRadius.sync="liActiveBorderRadius"
                  :borderTopLeftRadius.sync="liActiveBorderTopLeftRadius"
                  :borderTopRightRadius.sync="liActiveBorderTopRightRadius"
                  :borderBottomRightRadius.sync="liActiveBorderBottomRightRadius"
                  :borderBottomLeftRadius.sync="liActiveBorderBottomLeftRadius"
                />
              </div>
            </el-collapse-item>
          </template>
          <!-- 悬浮状态 -->
          <template v-if="statusType === '3'">
            <el-checkbox class="paddingl15 mb12 mt8" v-model="liHoverIsSameActive">同选中状态</el-checkbox>
            <div v-if="!liHoverIsSameActive">
              <el-collapse-item
                @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '5')"
                title="文字"
                name="5"
              >
                <div
                  class="setting-item"
                  v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '5')"
                >
                  <div class="content">
                    <text-setting-complex-update
                      :fontFamily.sync="liHoverFontFamily"
                      :fontSize.sync="liHoverFontSize"
                      :fontWeight.sync="liHoverFontWeight"
                      :fontStyle.sync="liHoverFontStyle"
                      :textDecoration.sync="liHoverTextDecoration"
                      :lineHeight.sync="liHoverLineHeight"
                      :letterSpacing.sync="liHoverLetterSpacing"
                      :activeArrangement.sync="liHoverActiveArrangement"
                      :writingMode.sync="liHoverWritingMode"
                      :textAlign.sync="liHoverTextAlign"
                      :activeArrangementOrder.sync="liHoverActiveArrangementOrder"
                      :lineHeightType.sync="liHoverLineHeightType"
                      :letterSpacingType.sync="liHoverLetterSpacingType"
                      :isThemeColor.sync="liHoverTextIsThemeColor"
                      :colorArr.sync="liHoverFontColor"
                      :options="options"
                    />
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item
                @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '6')"
                title="背景"
                name="6"
              >
                <div class="content-item clearFloat">
                  <cx-background :background.sync="liHoverBgColor" imgType="10" class="" />
                </div>
              </el-collapse-item>
              <el-collapse-item
                @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '8')"
                title="边框"
                name="8"
              >
                <div class="content-item">
                  <div class="content-item verticallyCenter mb12">
                    <el-checkbox v-model="liHoverShowBorder">显示边框</el-checkbox>
                  </div>
                  <cx-border
                    v-if="liHoverShowBorder"
                    :borderWidth.sync="liHoverBorderWidth"
                    :borderStyle.sync="liHoverBorderStyle"
                    :borderColor.sync="liHoverBorderColor"
                    :borderIsThemeColor.sync="liHoverBorderIsThemeColor"
                  />
                </div>
                <div class="content-item mt12">
                  <border-radius
                    :borderTypeFlag.sync="liHoverBorderTypeFlag"
                    :borderRadius.sync="liHoverBorderRadius"
                    :borderTopLeftRadius.sync="liHoverBorderTopLeftRadius"
                    :borderTopRightRadius.sync="liHoverBorderTopRightRadius"
                    :borderBottomRightRadius.sync="liHoverBorderBottomRightRadius"
                    :borderBottomLeftRadius.sync="liHoverBorderBottomLeftRadius"
                  />
                </div>
              </el-collapse-item>
            </div>
          </template>
        </template>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"
import TextSettingComplex from "modules/components/textSettingComplex"
import elementPluginSetting from "publicSetting/elementPluginSetting"
import { withMethodsHistoryCombine } from "utils/revork"
import rowColLayoutSize from "publicSetting/rowColLayoutSize"
import anchorSize from "./setting/anchorSize"
import { historyCombineWrap } from "utils/revork"
export default withMethodsHistoryCombine({
  name: "image-options-data",
  components: { controlWidthAndSizeAndZindex, TextSettingComplex, elementPluginSetting, rowColLayoutSize, anchorSize },
  props: { options: Object, activeType: String },
  data() {
    return {
      collapseActiveNames: ["1", "2", "4", "5", "6"],
      activeNames: ["1", "2", "4", "5", "6"],
      iptSliderMax: 360,
      curSub: 0,
      statusType: "1",
      statusTypeOptions: [
        { value: "1", title: "默认" },
        { value: "2", title: "选中" },
        { value: "3", title: "悬浮" }
      ],
      divideTypeOptions: [
        {
          value: "line",
          title: "竖线"
        },
        {
          value: "custom",
          title: "自定义"
        }
      ],
      alignmentTypeOptions: [
        {
          value: "left",
          label: "左对齐",
          iconClass: "icon-portal-Align-left"
        },
        {
          value: "center",
          label: "居中对齐",
          iconClass: "icon-portal-Center-lr"
        },
        {
          value: "right",
          label: "右对齐",
          iconClass: "icon-portal-Align-right"
        }
      ]
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    activeArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.writingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "writingMode", false)
      }
    },
    hoverArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.hoverWritingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "hoverWritingMode", false)
      }
    },
    activeArrangement() {
      return this.options.textAlign
    },
    hoverArrangement() {
      return this.options.hoverTextAlign
    },
    hoverBackground: {
      get() {
        let background = this.options.hoverBackground
        if (background && Array.isArray(background) && background.length > 0) {
          if (typeof background[0].color === "object") {
            background[0].color = background[0].color?.color
          }
          return background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hoverBgColorIsThemeColor,
            color: this.options.hoverBgColor.color ? this.options.hoverBgColor.color : this.options.hoverBgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "hoverBackground", false, false, false, true)
        return newBackground
      },
      set(newVal) {
        if (typeof newVal[0].color === "object") {
          newVal[0].color = newVal[0].color?.color
        }
        this.$changeOptionsEV(newVal, "hoverBackground", false)
      }
    },
    defaultBackground: {
      get() {
        let background = this.options.defaultBackground
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.defaultBackground
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.bgColorIsThemeColor,
            color: this.options.bgColor.color ? this.options.bgColor.color : this.options.bgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "defaultBackground", false, false, false, true)
        return newBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultBackground", false)
      }
    },
    activeBackground: {
      get() {
        let background = this.options.activeBackground
        if (background && Array.isArray(background) && background.length > 0) {
          if (typeof background[0].color === "object") {
            background[0].color = background[0].color?.color
          }
          return background
        }
        let newBackground = this.options.activeBgColor
          ? [
              {
                type: "color",
                label: "颜色",
                isThemeColor: this.options.activeBgColorIsThemeColor,
                color: this.options.activeBgColor.color ? this.options.activeBgColor.color : this.options.activeBgColor
              }
            ]
          : this.hoverBackground
        this.$changeOptionsEV(newBackground, "activeBackground", false, false, false, true)
        return newBackground
      },
      set(newVal) {
        if (typeof newVal[0].color === "object") {
          newVal[0].color = newVal[0].color?.color
        }
        this.$changeOptionsEV(newVal, "activeBackground", false)
      }
    },
    width: {
      get() {
        return this.options.width
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "width", false)
      }
    },
    height: {
      get() {
        return this.options.height
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "height", false)
      }
    },
    pluginName: {
      get() {
        if (!this.hasProperty(this.options, "pluginName")) {
          this.options.pluginName = []
          this.$changeOptionsEV([], "pluginName", false, false, false, true)
        }
        return this.options.pluginName
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pluginName", false)
      }
    },
    iconLocation: {
      get() {
        return this.options.iconLocation || "left"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconLocation", false)
      }
    },
    hoverBorderColor: {
      get() {
        return this.options.hoverBorderColor || this.options.activeBorderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderColor", false)
      }
    },
    fontFamily: {
      get() {
        return this.options.fontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontFamily", false)
      }
    },
    hoverFontFamily: {
      get() {
        return this.options.hoverFontFamily || this.options.activeFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverFontFamily", false)
      }
    },
    fontSize: {
      get() {
        return this.options.fontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontSize", false)
      }
    },
    hoverFontSize: {
      get() {
        return this.options.hoverFontSize || parseInt(this.options.activeFontSize)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverFontSize", false)
      }
    },
    fontWeight: {
      get() {
        return this.options.fontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontWeight", false)
      }
    },
    hoverFontWeight: {
      get() {
        return this.options.hoverFontWeight || this.options.activeFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverFontWeight", false)
      }
    },
    color: {
      get() {
        return this.options.color
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "color", false)
      }
    },
    textIsThemeColor: {
      get() {
        return this.options.textIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textIsThemeColor", false)
      }
    },
    hoverColor: {
      get() {
        return this.options.hoverColor || this.options.activeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverColor", false)
      }
    },
    hoverTextIsThemeColor: {
      get() {
        return this.options.hoverTextIsThemeColor || this.options.activeTextIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverTextIsThemeColor", false)
      }
    },
    textAlign: {
      get() {
        return this.options.textAlign
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textAlign", false)
      }
    },
    hoverTextAlign: {
      get() {
        return this.options.hoverTextAlign || this.options.activeTextAlign
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverTextAlign", false)
      }
    },
    fontStyle: {
      get() {
        return this.options.fontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontStyle", false)
      }
    },
    hoverFontStyle: {
      get() {
        return this.options.hoverFontStyle || this.options.activeFontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverFontStyle", false)
      }
    },
    lineHeight: {
      get() {
        return this.options.lineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineHeight", false)
      }
    },
    hoverLineHeight: {
      get() {
        return this.options.hasOwnProperty("hoverLineHeight")
          ? this.options.hoverLineHeight
          : this.options.activeLineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverLineHeight", false)
      }
    },
    letterSpacing: {
      get() {
        return this.options.letterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(`${newVal}`, "letterSpacing", false)
      }
    },
    hoverLetterSpacing: {
      get() {
        return this.options.hasOwnProperty("hoverLetterSpacing")
          ? this.options.hoverLetterSpacing
          : this.options.activeLetterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(`${newVal}`, "hoverLetterSpacing", false)
      }
    },
    writingMode: {
      get() {
        return this.options.writingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "writingMode", false)
      }
    },
    hoverWritingMode: {
      get() {
        return this.options.hasOwnProperty("hoverWritingMode")
          ? this.options.hoverWritingMode
          : this.options.activeWritingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverWritingMode", false)
      }
    },
    textDecoration: {
      get() {
        return this.options.textDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textDecoration", false)
      }
    },
    hoverTextDecoration: {
      get() {
        return this.options.hoverTextDecoration || this.options.activeTextDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverTextDecoration", false)
      }
    },
    widthAuto: {
      get() {
        return this.options.widthAuto || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "widthAuto", false)
      }
    },
    anchorWidth: {
      get() {
        return this.options.anchorWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "anchorWidth", false)
      }
    },
    anchorHeight: {
      get() {
        return this.options.anchorHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "anchorHeight", false)
      }
    },
    bgColor: {
      get() {
        return this.options.bgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgColor", false)
      }
    },
    hoverBgColor: {
      get() {
        return this.options.hoverBgColor || this.options.activeBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBgColor", false)
      }
    },
    marginRight: {
      get() {
        return this.options.marginRight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "marginRight", false)
      }
    },
    marginBottom: {
      get() {
        return this.options.marginBottom
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "marginBottom", false)
      }
    },
    borderTopLeftRadius: {
      get() {
        return this.options.borderTopLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopLeftRadius", false)
      }
    },
    borderTopRightRadius: {
      get() {
        return this.options.borderTopRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopRightRadius", false)
      }
    },
    borderBottomRightRadius: {
      get() {
        return this.options.borderBottomRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomRightRadius", false)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return this.options.borderBottomLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomLeftRadius", false)
      }
    },
    borderRadius: {
      get() {
        return this.options.borderBottomLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal],
          ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"],
          false
        )
      }
    },
    borderStyle: {
      get() {
        return this.options.borderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderStyle", false)
      }
    },
    borderColor: {
      get() {
        return this.options.borderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderColor", false)
      }
    },
    borderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("borderTypeFlag")) {
          if (
            ((this.borderTopLeftRadius === this.borderTopRightRadius) === this.borderBottomLeftRadius) ===
            this.borderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        return this.options.borderTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTypeFlag", false)
      }
    },
    showBorder: {
      get() {
        let showBorder = false
        if (this.options.showBorder === undefined) {
          if (Array.isArray(this.options.borderWidth)) {
            let allZero = true
            for (let i = 0; i < this.options.borderWidth.length; i++) {
              if (this.options.borderWidth[i] !== 0) {
                allZero = false
              }
            }
            if (allZero) {
              showBorder = false
            } else {
              showBorder = true
            }
          } else {
            if (this.options.borderWidth) {
              showBorder = true
            } else {
              showBorder = false
            }
          }
          this.$changeOptionsEV(showBorder, "showBorder", false)
        } else {
          showBorder = this.options.showBorder
        }
        return showBorder
      },
      set(newVal) {
        if (newVal && !this.borderWidth) {
          this.$changeOptionsEV([1, newVal], ["borderWidth", "showBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "showBorder", false)
        }
      }
    },
    borderWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderWidth", "borderWidth", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderWidth", false)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.options.borderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderIsThemeColor", false)
      }
    },
    hoverBorderIsThemeColor: {
      get() {
        return this.options.hasOwnProperty("hoverBorderIsThemeColor")
          ? this.options.hoverBorderIsThemeColor
          : this.activeBorderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderIsThemeColor", false)
      }
    },
    bgColorIsThemeColor: {
      get() {
        return this.options.hasOwnProperty("bgColorIsThemeColor") ? this.options.bgColorIsThemeColor : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgColorIsThemeColor", false)
      }
    },
    hoverBgColorIsThemeColor: {
      get() {
        return this.options.hasOwnProperty("hoverBgColorIsThemeColor") ? this.options.hoverBgColorIsThemeColor : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBgColorIsThemeColor", false)
      }
    },
    showHoverBorder: {
      get() {
        let showBorder = false
        if (this.options.showHoverBorder === undefined) {
          if (Array.isArray(this.options.hoverBorderWidth)) {
            let allZero = true
            for (let i = 0; i < this.options.hoverBorderWidth.length; i++) {
              if (this.options.hoverBorderWidth[i] !== 0) {
                allZero = false
              }
            }
            if (allZero) {
              showBorder = false
            } else {
              showBorder = true
            }
          } else {
            if (this.options.hoverBorderWidth) {
              showBorder = true
            } else {
              showBorder = false
            }
          }
          this.$changeOptionsEV(showBorder, "showHoverBorder", false)
        } else {
          showBorder = this.options.showHoverBorder
        }
        return showBorder
      },
      set(newVal) {
        if (newVal && !this.hoverBorderWidth) {
          this.$changeOptionsEV([1, newVal], ["hoverBorderWidth", "showHoverBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "showHoverBorder", false)
        }
      }
    },
    hoverBorderWidth: {
      get() {
        return this.options.hasOwnProperty("hoverBorderWidth")
          ? this.options.hoverBorderWidth
          : this.options.activeBorderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderWidth", false)
      }
    },
    hoverBorderStyle: {
      get() {
        return this.options.hasOwnProperty("hoverBorderStyle")
          ? this.options.hoverBorderStyle
          : this.options.activeBorderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderStyle", false)
      }
    },
    opacity: {
      get() {
        return this.options.hasOwnProperty("opacity") ? this.options.opacity : 100
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "opacity", false)
      }
    },
    anchorOpacity: {
      get() {
        return this.options.hasOwnProperty("anchorOpacity") ? this.options.anchorOpacity : 100
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "anchorOpacity", false)
      }
    },
    background: {
      get() {
        let background = this.options.background
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.background
        }
        let newBackground = []
        if (this.bgType === "线性渐变") {
          newBackground.push({
            type: "linearGradient",
            label: "线性渐变",
            data: {
              angle: this.bgColorlinearGradientAngle,
              stops: [
                [this.bgStartColor, 0],
                [this.bgEndColor, 1]
              ]
            }
          })
        }
        if (this.bgType === "径向渐变") {
          newBackground.push({
            type: "radialGradient",
            label: "径向渐变",
            data: {
              siteX: 50,
              siteY: 50,
              stops: [
                [this.bgStartColor, 0],
                [this.bgEndColor, 1]
              ]
            }
          })
        }
        newBackground.push({
          type: "color",
          label: "颜色",
          isThemeColor: false,
          color: this.bgType === "纯色" ? this.allBgColor : "rgba(0,0,0,0)"
        })
        this.$changeOptionsEV(newBackground, "background", false, false, false, true)
        return newBackground
      },
      set(val) {
        this.$changeOptionsEV(val, "background", false)
      }
    },
    bgType: {
      get() {
        return this.options.bgType || "纯色"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgType", false)
      }
    },
    allBgColor: {
      get() {
        return this.options.allBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBgColor", false)
      }
    },
    bgStartColor: {
      get() {
        return this.options.bgStartColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgStartColor", false)
      }
    },
    bgEndColor: {
      get() {
        return this.options.bgEndColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgEndColor", false)
      }
    },
    boxShadowColor: {
      get() {
        return this.options.hasOwnProperty("boxShadowColor") ? this.options.boxShadowColor : ["rgba(255,255,255,1)"]
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowColor", false)
      }
    },
    boxShadowH: {
      get() {
        return this.options.hasOwnProperty("boxShadowH") ? this.options.boxShadowH : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowH", false)
      }
    },
    boxShadowV: {
      get() {
        return this.options.hasOwnProperty("boxShadowV") ? this.options.boxShadowV : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowV", false)
      }
    },
    boxShadowBlur: {
      get() {
        return this.options.hasOwnProperty("boxShadowBlur") ? this.options.boxShadowBlur : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowBlur", false)
      }
    },
    boxShadowSpread: {
      get() {
        return this.options.hasOwnProperty("boxShadowSpread") ? this.options.boxShadowSpread : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowSpread", false)
      }
    },
    defaultBoxShadowColor: {
      get() {
        return this.options.hasOwnProperty("defaultBoxShadowColor") ? this.options.defaultBoxShadowColor : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultBoxShadowColor", false)
      }
    },
    defaultBoxShadowH: {
      get() {
        return this.options.hasOwnProperty("defaultBoxShadowH") ? this.options.defaultBoxShadowH : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultBoxShadowH", false)
      }
    },
    defaultBoxShadowV: {
      get() {
        return this.options.hasOwnProperty("defaultBoxShadowV") ? this.options.defaultBoxShadowV : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultBoxShadowV", false)
      }
    },
    defaultBoxShadowBlur: {
      get() {
        return this.options.hasOwnProperty("defaultBoxShadowBlur") ? this.options.defaultBoxShadowBlur : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultBoxShadowBlur", false)
      }
    },
    defaultBoxShadowSpread: {
      get() {
        return this.options.hasOwnProperty("defaultBoxShadowSpread") ? this.options.defaultBoxShadowSpread : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultBoxShadowSpread", false)
      }
    },
    allBorderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("allBorderTypeFlag")) {
          if (
            ((this.allBorderTopLeftRadius === this.allBorderTopRightRadius) === this.allBorderBottomLeftRadius) ===
            this.allBorderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        return this.options.allBorderTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBorderTypeFlag", false)
      }
    },
    allBorderRadius: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "allBorderRadius",
          "allBorderRadius",
          this.allBorderTopLeftRadius
        )
      },
      set(newVal) {
        if (this.allBorderTypeFlag === 2) {
          this.allBorderTopLeftRadius = newVal
          this.allBorderTopRightRadius = newVal
          this.allBorderBottomLeftRadius = newVal
          this.allBorderBottomRightRadius = newVal
        }
        this.$changeOptionsEV(newVal, "borderRadius", false)
      }
    },
    allBorderTopLeftRadius: {
      get() {
        return this.options.allBorderTopLeftRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBorderTopLeftRadius", false)
      }
    },
    allBorderTopRightRadius: {
      get() {
        return this.options.allBorderTopRightRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBorderTopRightRadius", false)
      }
    },
    allBorderBottomLeftRadius: {
      get() {
        return this.options.allBorderBottomLeftRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBorderBottomLeftRadius", false)
      }
    },
    allBorderBottomRightRadius: {
      get() {
        return this.options.allBorderBottomRightRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBorderBottomRightRadius", false)
      }
    },
    allBorderIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "allBorderIsThemeColor", "allBorderIsThemeColor", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBorderIsThemeColor", false)
      }
    },
    showAllBorder: {
      get() {
        let showBorder = false
        if (this.options.showAllBorder === undefined) {
          if (Array.isArray(this.options.allBorderWidth)) {
            let allZero = true
            for (let i = 0; i < this.options.allBorderWidth.length; i++) {
              if (this.options.allBorderWidth[i] !== 0) {
                allZero = false
              }
            }
            if (allZero) {
              showBorder = false
            } else {
              showBorder = true
            }
          } else {
            if (this.options.allBorderWidth) {
              showBorder = true
            } else {
              showBorder = false
            }
          }
          this.$changeOptionsEV(showBorder, "showAllBorder", false, false, false, true)
        } else {
          showBorder = this.options.showAllBorder
        }
        return showBorder
      },
      set(newVal) {
        if (newVal && !this.allBorderWidth) {
          this.$changeOptionsEV([1, newVal], ["allBorderWidth", "showAllBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "showAllBorder", false)
        }
      }
    },
    allBorderWidth: {
      get() {
        return this.options.hasOwnProperty("allBorderWidth") ? this.options.allBorderWidth : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBorderWidth", false)
      }
    },
    allBorderStyle: {
      get() {
        return this.options.hasOwnProperty("allBorderStyle") ? this.options.allBorderStyle : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBorderStyle", false)
      }
    },
    allBorderColor: {
      get() {
        return this.options.hasOwnProperty("allBorderColor") ? this.options.allBorderColor : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBorderColor", false)
      }
    },
    contentHasLimit: {
      get() {
        return this.options.contentHasLimit
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "contentHasLimit", false)
      }
    },
    contentHasLimitRadio: {
      get() {
        return this.options.hasOwnProperty("contentHasLimitRadio") ? this.options.contentHasLimitRadio : "字数"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "contentHasLimitRadio", false)
      }
    },
    textLimitLines: {
      get() {
        return this.options.textLimitLines
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textLimitLines", false)
      }
    },
    textLimitWords: {
      get() {
        return this.options.textLimitWords || 1
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textLimitWords", false)
      }
    },
    // 整体边距
    ulPaddingTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("ulPaddingTypeFlag")) {
          if (((this.paddingTop === this.paddingRight) === this.paddingLeft) === this.paddingBottom) {
            defaultType = 2
          }
        }
        return this.options.ulPaddingTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulPaddingTypeFlag", false)
      }
    },
    ulPadding: {
      get() {
        return this.options.ulPadding || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulPadding", false)
      }
    },
    ulPaddingTop: {
      get() {
        return this.options.ulPaddingTop || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulPaddingTop", false)
      }
    },
    ulPaddingRight: {
      get() {
        return this.options.ulPaddingRight || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulPaddingRight", false)
      }
    },
    ulPaddingLeft: {
      get() {
        return this.options.ulPaddingLeft || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulPaddingLeft", false)
      }
    },
    ulPaddingBottom: {
      get() {
        return this.options.ulPaddingBottom || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulPaddingBottom", false)
      }
    },
    // 边距
    paddingTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("paddingTypeFlag")) {
          if (((this.paddingTop === this.paddingRight) === this.paddingLeft) === this.paddingBottom) {
            defaultType = 2
          }
        }
        return this.options.paddingTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTypeFlag", false)
      }
    },
    padding: {
      get() {
        return this.options.padding || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "padding", false)
      }
    },
    paddingTop: {
      get() {
        return this.options.paddingTop || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTop", false)
      }
    },
    paddingRight: {
      get() {
        return this.options.paddingRight || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingRight", false)
      }
    },
    paddingLeft: {
      get() {
        return this.options.paddingLeft || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingLeft", false)
      }
    },
    paddingBottom: {
      get() {
        return this.options.paddingBottom || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingBottom", false)
      }
    },
    lineHeightType: {
      get() {
        return this.options.lineHeightType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineHeightType", false)
      }
    },
    letterSpacingType: {
      get() {
        return this.options.letterSpacingType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "letterSpacingType", false)
      }
    },
    hoverLineHeightType: {
      get() {
        return this.options.hoverLineHeightType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverLineHeightType", false)
      }
    },
    hoverLetterSpacingType: {
      get() {
        return this.options.hoverLetterSpacingType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverLetterSpacingType", false)
      }
    },
    showIcon: {
      get() {
        return this.options.hasOwnProperty("showIcon") ? this.options.showIcon : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showIcon", false)
      }
    },
    iconSrc: {
      get() {
        return this.options.hasOwnProperty("iconSrc") ? this.options.iconSrc : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconSrc", false)
      }
    },
    iconWidth: {
      get() {
        return this.options.hasOwnProperty("iconWidth") ? this.options.iconWidth : 14
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconWidth", false)
      }
    },
    iconHeight: {
      get() {
        return this.options.hasOwnProperty("iconHeight") ? this.options.iconHeight : 14
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconHeight", false)
      }
    },
    iconMargin: {
      get() {
        return this.options.hasOwnProperty("iconMargin") ? this.options.iconMargin : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconMargin", false)
      }
    },
    iconColor: {
      get() {
        return this.options.hasOwnProperty("iconColor") ? this.options.iconColor : "#000"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconColor", false)
      }
    },
    iconColorIsThemeColor: {
      get() {
        return this.options.hasOwnProperty("iconColorIsThemeColor") ? this.options.iconColorIsThemeColor : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconColorIsThemeColor", false)
      }
    },
    resInfo: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "resInfo", "resInfo", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "resInfo", false)
      }
    },
    iconPosition: {
      get() {
        return this.options.hasOwnProperty("iconPosition") ? this.options.iconPosition : "left"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconPosition", false)
      }
    },
    iconType: {
      get() {
        return this.options.hasOwnProperty("iconType") ? this.options.iconType : "img"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconType", false)
      }
    },
    activeShowIcon: {
      get() {
        return this.options.hasOwnProperty("activeShowIcon") ? this.options.activeShowIcon : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeShowIcon", false)
      }
    },
    activeIconSrc: {
      get() {
        return this.options.hasOwnProperty("activeIconSrc") ? this.options.activeIconSrc : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeIconSrc", false)
      }
    },
    activeIconWidth: {
      get() {
        return this.options.hasOwnProperty("activeIconWidth") ? this.options.activeIconWidth : 14
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeIconWidth", false)
      }
    },
    activeIconHeight: {
      get() {
        return this.options.hasOwnProperty("activeIconHeight") ? this.options.activeIconHeight : 14
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeIconHeight", false)
      }
    },
    activeIconMargin: {
      get() {
        return this.options.hasOwnProperty("activeIconMargin") ? this.options.activeIconMargin : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeIconMargin", false)
      }
    },
    activeIconColor: {
      get() {
        return this.options.hasOwnProperty("activeIconColor") ? this.options.activeIconColor : "#000"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeIconColor", false)
      }
    },
    activeIconColorIsThemeColor: {
      get() {
        return this.options.hasOwnProperty("activeIconColorIsThemeColor")
          ? this.options.activeIconColorIsThemeColor
          : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeIconColorIsThemeColor", false)
      }
    },
    activeResInfo: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "activeResInfo", "activeResInfo", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeResInfo", false)
      }
    },
    activeIconPosition: {
      get() {
        return this.options.hasOwnProperty("activeIconPosition") ? this.options.activeIconPosition : "left"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeIconPosition", false)
      }
    },
    activeIconType: {
      get() {
        return this.options.hasOwnProperty("activeIconType") ? this.options.activeIconType : "img"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeIconType", false)
      }
    },
    liActiveShowIcon: {
      get() {
        return this.options.hasOwnProperty("liActiveShowIcon") ? this.options.liActiveShowIcon : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveShowIcon", false)
      }
    },
    liActiveIconSrc: {
      get() {
        return this.options.hasOwnProperty("liActiveIconSrc") ? this.options.liActiveIconSrc : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveIconSrc", false)
      }
    },
    liActiveIconWidth: {
      get() {
        return this.options.hasOwnProperty("liActiveIconWidth") ? this.options.liActiveIconWidth : 14
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveIconWidth", false)
      }
    },
    liActiveIconHeight: {
      get() {
        return this.options.hasOwnProperty("liActiveIconHeight") ? this.options.liActiveIconHeight : 14
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveIconHeight", false)
      }
    },
    liActiveIconMargin: {
      get() {
        return this.options.hasOwnProperty("liActiveIconMargin") ? this.options.liActiveIconMargin : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveIconMargin", false)
      }
    },
    liActiveIconColor: {
      get() {
        return this.options.hasOwnProperty("liActiveIconColor") ? this.options.liActiveIconColor : "#000"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveIconColor", false)
      }
    },
    liActiveIconColorIsThemeColor: {
      get() {
        return this.options.hasOwnProperty("liActiveIconColorIsThemeColor")
          ? this.options.liActiveIconColorIsThemeColor
          : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveIconColorIsThemeColor", false)
      }
    },
    liActiveResInfo: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liActiveResInfo", "liActiveResInfo", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveResInfo", false)
      }
    },
    liActiveIconPosition: {
      get() {
        return this.options.hasOwnProperty("liActiveIconPosition") ? this.options.liActiveIconPosition : "left"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveIconPosition", false)
      }
    },
    liActiveIconType: {
      get() {
        return this.options.hasOwnProperty("liActiveIconType") ? this.options.liActiveIconType : "img"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveIconType", false)
      }
    },
    showAnchorScorll: {
      get() {
        return this.options.hasOwnProperty("showAnchorScorll") ? this.options.showAnchorScorll : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showAnchorScorll", false)
      }
    },
    hoverBorderTopLeftRadius: {
      get() {
        return this.options.hasOwnProperty("hoverBorderTopLeftRadius")
          ? this.options.hoverBorderTopLeftRadius
          : this.activeBorderTopLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderTopLeftRadius", false)
      }
    },
    hoverBorderTopRightRadius: {
      get() {
        return this.options.hasOwnProperty("hoverBorderTopRightRadius")
          ? this.options.hoverBorderTopRightRadius
          : this.activeBorderTopRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderTopRightRadius", false)
      }
    },
    hoverBorderBottomRightRadius: {
      get() {
        return this.options.hasOwnProperty("hoverBorderBottomRightRadius")
          ? this.options.hoverBorderBottomRightRadius
          : this.activeBorderBottomRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderBottomRightRadius", false)
      }
    },
    hoverBorderBottomLeftRadius: {
      get() {
        return this.options.hasOwnProperty("hoverBorderBottomLeftRadius")
          ? this.options.hoverBorderBottomLeftRadius
          : this.activeBorderBottomLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderBottomLeftRadius", false)
      }
    },
    hoverBorderRadius: {
      get() {
        return this.options.hasOwnProperty("hoverBorderRadius")
          ? this.options.hoverBorderRadius
          : this.activeBorderRadius
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal],
          [
            "hoverBorderTopLeftRadius",
            "hoverBorderTopRightRadius",
            "hoverBorderBottomRightRadius",
            "hoverBorderBottomLeftRadius"
          ],
          false
        )
        this.$changeOptionsEV(newVal, "hoverBorderRadius", false)
      }
    },
    hoverBorderTypeFlag: {
      get() {
        let defaultType = this.activeBorderTypeFlag
        if (!this.options.hasOwnProperty("hoverBorderTypeFlag")) {
          if (
            ((this.hoverBorderTopLeftRadius === this.hoverBorderTopRightRadius) ===
              this.hoverBorderBottomLeftRadius) ===
            this.hoverBorderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        // 上面方法貌似是执行需要一定的时间，造成最开始还未写入值，进行点击 会出现问题
        return this.options.hoverBorderTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderTypeFlag", false)
      }
    },
    hoverIsSameActive: {
      get() {
        return this.options.hasOwnProperty("hoverIsSameActive") ? this.options.hoverIsSameActive : true
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverIsSameActive", false)
      }
    },
    liHoverIsSameActive: {
      get() {
        return this.options.hasOwnProperty("liHoverIsSameActive") ? this.options.liHoverIsSameActive : true
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverIsSameActive", false)
      }
    },
    activeFontFamily: {
      get() {
        return this.options.activeFontFamily || this.options.fontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontFamily", false)
      }
    },
    activeFontSize: {
      get() {
        return this.options.activeFontSize || parseInt(this.options.fontSize)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontSize", false)
      }
    },
    activeFontWeight: {
      get() {
        return this.options.activeFontWeight || this.options.fontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontWeight", false)
      }
    },
    activeColor: {
      get() {
        return this.options.activeColor || this.options.color
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeColor", false)
      }
    },
    activeTextIsThemeColor: {
      get() {
        return this.options.hasOwnProperty("activeTextIsThemeColor")
          ? this.options.activeTextIsThemeColor
          : this.options.textIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeTextIsThemeColor", false)
      }
    },
    activeTextAlign: {
      get() {
        return this.options.activeTextAlign || this.options.textAlign
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeTextAlign", false)
      }
    },
    activeFontStyle: {
      get() {
        return this.options.activeFontStyle || this.options.fontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontStyle", false)
      }
    },
    activeLineHeight: {
      get() {
        return this.options.hasOwnProperty("activeLineHeight") ? this.options.activeLineHeight : this.options.lineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeLineHeight", false)
      }
    },
    activeLetterSpacing: {
      get() {
        return this.options.hasOwnProperty("activeLetterSpacing")
          ? this.options.activeLetterSpacing
          : this.options.letterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(`${newVal}`, "activeLetterSpacing", false)
      }
    },
    activeWritingMode: {
      get() {
        return this.options.hasOwnProperty("activeWritingMode")
          ? this.options.activeWritingMode
          : this.options.writingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeWritingMode", false)
      }
    },
    activeTextDecoration: {
      get() {
        return this.options.activeTextDecoration || this.options.textDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeTextDecoration", false)
      }
    },
    activeBgColor: {
      get() {
        return this.options.activeBgColor || this.options.bgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBgColor", false)
      }
    },
    activeBgColorIsThemeColor: {
      get() {
        return this.options.hasOwnProperty("activeBgColorIsThemeColor") ? this.options.activeBgColorIsThemeColor : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBgColorIsThemeColor", false)
      }
    },
    activeBorderIsThemeColor: {
      get() {
        return this.options.hasOwnProperty("activeBorderIsThemeColor")
          ? this.options.activeBorderIsThemeColor
          : this.borderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderIsThemeColor", false)
      }
    },
    showActiveBorder: {
      get() {
        let showBorder = false
        if (this.options.showActiveBorder === undefined) {
          if (Array.isArray(this.options.activeBorderWidth)) {
            let allZero = true
            for (let i = 0; i < this.options.activeBorderWidth.length; i++) {
              if (this.options.activeBorderWidth[i] !== 0) {
                allZero = false
              }
            }
            if (allZero) {
              showBorder = false
            } else {
              showBorder = true
            }
          } else {
            if (this.options.activeBorderWidth) {
              showBorder = true
            } else {
              showBorder = false
            }
          }
        } else {
          showBorder = this.options.showActiveBorder
        }
        return showBorder
      },
      set(newVal) {
        if (newVal && !this.activeBorderWidth) {
          this.$changeOptionsEV([1, newVal], ["activeBorderWidth", "showActiveBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "showActiveBorder", false)
        }
      }
    },
    activeBorderWidth: {
      get() {
        return this.options.hasOwnProperty("activeBorderWidth")
          ? this.options.activeBorderWidth
          : this.options.borderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderWidth", false)
      }
    },
    activeBorderColor: {
      get() {
        return this.options.activeBorderColor || this.options.borderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderColor", false)
      }
    },
    activeBorderStyle: {
      get() {
        return this.options.hasOwnProperty("activeBorderStyle")
          ? this.options.activeBorderStyle
          : this.options.borderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderStyle", false)
      }
    },
    activeActiveArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.activeWritingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "activeWritingMode", false)
      }
    },
    activeActiveArrangement() {
      return this.options.activeTextAlign
    },
    activeLineHeightType: {
      get() {
        return this.options.activeLineHeightType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeLineHeightType", false)
      }
    },
    activeLetterSpacingType: {
      get() {
        return this.options.activeLetterSpacingType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeLetterSpacingType", false)
      }
    },
    activeBorderTopLeftRadius: {
      get() {
        return this.options.hasOwnProperty("activeBorderTopLeftRadius")
          ? this.options.activeBorderTopLeftRadius
          : this.borderTopLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderTopLeftRadius", false)
      }
    },
    activeBorderTopRightRadius: {
      get() {
        return this.options.hasOwnProperty("activeBorderTopRightRadius")
          ? this.options.activeBorderTopRightRadius
          : this.borderTopRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderTopRightRadius", false)
      }
    },
    activeBorderBottomRightRadius: {
      get() {
        return this.options.hasOwnProperty("activeBorderBottomRightRadius")
          ? this.options.activeBorderBottomRightRadius
          : this.borderBottomRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderBottomRightRadius", false)
      }
    },
    activeBorderBottomLeftRadius: {
      get() {
        return this.options.hasOwnProperty("activeBorderBottomLeftRadius")
          ? this.options.activeBorderBottomLeftRadius
          : this.borderBottomLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderBottomLeftRadius", false)
      }
    },
    activeBorderRadius: {
      get() {
        return this.options.hasOwnProperty("activeBorderRadius") ? this.options.activeBorderRadius : this.borderRadius
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal],
          [
            "activeBorderTopLeftRadius",
            "activeBorderTopRightRadius",
            "activeBorderBottomRightRadius",
            "activeBorderBottomLeftRadius"
          ],
          false
        )
        this.$changeOptionsEV(newVal, "activeBorderRadius", false)
      }
    },
    activeBorderTypeFlag: {
      get() {
        let defaultType = this.borderTypeFlag
        if (!this.options.hasOwnProperty("activeBorderTypeFlag")) {
          if (
            ((this.activeBorderTopLeftRadius === this.activeBorderTopRightRadius) ===
              this.activeBorderBottomLeftRadius) ===
            this.activeBorderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        // 上面方法貌似是执行需要一定的时间，造成最开始还未写入值，进行点击 会出现问题
        return this.options.activeBorderTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderTypeFlag", false)
      }
    },
    /* 悬浮样式end */
    showDivide: {
      get() {
        return this.options.hasOwnProperty("showDivide") ? this.options.showDivide : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showDivide", false)
      }
    },
    divideType: {
      get() {
        return this.options.hasOwnProperty("divideType") ? this.options.divideType : "line"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "divideType", false)
      }
    },
    divideWidth: {
      get() {
        return this.options.hasOwnProperty("divideWidth") ? this.options.divideWidth : 1
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "divideWidth", false)
      }
    },
    divideHeight: {
      get() {
        return this.options.hasOwnProperty("divideHeight") ? this.options.divideHeight : 24
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "divideHeight", false)
      }
    },
    divideIconSrc: {
      get() {
        return this.options.hasOwnProperty("divideIconSrc") ? this.options.divideIconSrc : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "divideIconSrc", false)
      }
    },
    divideIconType: {
      get() {
        return this.options.hasOwnProperty("divideIconType") ? this.options.divideIconType : "icon"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "divideIconType", false)
      }
    },
    divideIconColorIsThemeColor: {
      get() {
        return this.options.hasOwnProperty("divideIconColorIsThemeColor")
          ? this.options.divideIconColorIsThemeColor
          : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "divideIconColorIsThemeColor", false)
      }
    },
    divideIconColor: {
      get() {
        return this.options.hasOwnProperty("divideIconColor") ? this.options.divideIconColor : "rgba(0,0,0,0.2)"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "divideIconColor", false)
      }
    },
    divideResInfo: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "divideResInfo", "divideResInfo", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "divideResInfo", false)
      }
    },
    alignmentType: {
      get() {
        return this.options.alignmentType || "left"
      },
      set(val) {
        this.$changeOptionsEV(val, "alignmentType", false)
      }
    },
    indent: {
      get() {
        return this.options.indent
      },
      set(newVal) {
        newVal !== this.indent && this.$changeOptionsEV(newVal, "indent", false)
      }
    },
    liFontFamily: {
      get() {
        return this.options.liFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liFontFamily", false)
      }
    },
    liFontSize: {
      get() {
        return this.options.liFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liFontSize", false)
      }
    },
    liFontWeight: {
      get() {
        return this.options.liFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liFontWeight", false)
      }
    },
    liFontStyle: {
      get() {
        return this.options.liFontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liFontStyle", false)
      }
    },
    liTextDecoration: {
      get() {
        return this.options.liTextDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liTextDecoration", false)
      }
    },
    liLineHeight: {
      get() {
        return this.options.liLineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liLineHeight", false)
      }
    },
    liLetterSpacing: {
      get() {
        return this.options.liLetterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(`${newVal}`, "liLetterSpacing", false)
      }
    },
    liActiveArrangement() {
      return this.options.liTextAlign
    },
    liWritingMode: {
      get() {
        return this.options.liWritingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liWritingMode", false)
      }
    },
    liTextAlign: {
      get() {
        return this.options.liTextAlign
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liTextAlign", false)
      }
    },
    liActiveArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.liWritingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "liWritingMode", false)
      }
    },
    liLineHeightType: {
      get() {
        return this.options.liLineHeightType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liLineHeightType", false)
      }
    },
    liLetterSpacingType: {
      get() {
        return this.options.liLetterSpacingType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liLetterSpacingType", false)
      }
    },
    liTextIsThemeColor: {
      get() {
        return this.options.liTextIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liTextIsThemeColor", false)
      }
    },
    liFontColor: {
      get() {
        return this.options.liFontColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liFontColor", false)
      }
    },
    liContentHasLimit: {
      get() {
        return this.options.liContentHasLimit
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liContentHasLimit", false)
      }
    },
    liContentHasLimitRadio: {
      get() {
        return this.options.liContentHasLimitRadio || "字数"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liContentHasLimitRadio", false)
      }
    },
    liTextLimitLines: {
      get() {
        return this.options.liTextLimitLines || 4
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liTextLimitLines", false)
      }
    },
    liTextLimitWords: {
      get() {
        return this.options.liTextLimitWords || 1
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liTextLimitWords", false)
      }
    },
    liBgColor: {
      get() {
        let background = this.options.liBgColor
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.liBgColor
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.bgColorIsThemeColor,
            color: this.options.bgColor.color ? this.options.bgColor.color : this.options.bgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "liBgColor", false, false, false, true)
        return newBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBgColor", false)
      }
    },
    liShowIcon: {
      get() {
        return this.options.hasOwnProperty("liShowIcon") ? this.options.liShowIcon : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liShowIcon", false)
      }
    },
    liIconSrc: {
      get() {
        return this.options.hasOwnProperty("liIconSrc") ? this.options.liIconSrc : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liIconSrc", false)
      }
    },
    liIconType: {
      get() {
        return this.options.hasOwnProperty("liIconType") ? this.options.liIconType : "img"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liIconType", false)
      }
    },
    liIconColor: {
      get() {
        return this.options.hasOwnProperty("liIconColor") ? this.options.liIconColor : "#000"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liIconColor", false)
      }
    },
    liIconColorIsThemeColor: {
      get() {
        return this.options.hasOwnProperty("liIconColorIsThemeColor") ? this.options.liIconColorIsThemeColor : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liIconColorIsThemeColor", false)
      }
    },
    liResInfo: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liResInfo", "liResInfo", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liResInfo", false)
      }
    },
    liIconPosition: {
      get() {
        return this.options.hasOwnProperty("liIconPosition") ? this.options.liIconPosition : "left"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liIconPosition", false)
      }
    },
    liIconWidth: {
      get() {
        return this.options.hasOwnProperty("liIconWidth") ? this.options.liIconWidth : 14
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liIconWidth", false)
      }
    },
    liIconHeight: {
      get() {
        return this.options.hasOwnProperty("liIconHeight") ? this.options.liIconHeight : 14
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liIconHeight", false)
      }
    },
    liIconMargin: {
      get() {
        return this.options.hasOwnProperty("liIconMargin") ? this.options.liIconMargin : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liIconMargin", false)
      }
    },
    liShowBorder: {
      get() {
        let liShowBorder = false
        if (this.options.liShowBorder === undefined) {
          if (Array.isArray(this.options.liBorderWidth)) {
            let allZero = true
            for (let i = 0; i < this.options.liBorderWidth.length; i++) {
              if (this.options.liBorderWidth[i] !== 0) {
                allZero = false
              }
            }
            if (allZero) {
              liShowBorder = false
            } else {
              liShowBorder = true
            }
          } else {
            if (this.options.liBorderWidth) {
              liShowBorder = true
            } else {
              liShowBorder = false
            }
          }
          this.$changeOptionsEV(liShowBorder, "liShowBorder", false)
        } else {
          liShowBorder = this.options.liShowBorder
        }
        return liShowBorder
      },
      set(newVal) {
        if (newVal && !this.liBorderWidth) {
          this.$changeOptionsEV([1, newVal], ["liBorderWidth", "liShowBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "liShowBorder", false)
        }
      }
    },
    liBorderWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liBorderWidth", "liBorderWidth", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBorderWidth", false)
      }
    },
    liBorderStyle: {
      get() {
        return this.options.liBorderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBorderStyle", false)
      }
    },
    liBorderColor: {
      get() {
        return this.options.liBorderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBorderColor", false)
      }
    },
    liBorderIsThemeColor: {
      get() {
        return this.options.liBorderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBorderIsThemeColor", false)
      }
    },
    liBorderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("liBorderTypeFlag")) {
          if (
            ((this.liBorderTopLeftRadius === this.liBorderTopRightRadius) === this.liBorderBottomLeftRadius) ===
            this.liBorderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        return this.options.liBorderTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBorderTypeFlag", false)
      }
    },
    liBorderTopLeftRadius: {
      get() {
        return this.options.liBorderTopLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBorderTopLeftRadius", false)
      }
    },
    liBorderTopRightRadius: {
      get() {
        return this.options.liBorderTopRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBorderTopRightRadius", false)
      }
    },
    liBorderBottomRightRadius: {
      get() {
        return this.options.liBorderBottomRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBorderBottomRightRadius", false)
      }
    },
    liBorderBottomLeftRadius: {
      get() {
        return this.options.liBorderBottomLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBorderBottomLeftRadius", false)
      }
    },
    liBorderRadius: {
      get() {
        return this.options.liBorderBottomLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal],
          ["liBorderTopLeftRadius", "liBorderTopRightRadius", "liBorderBottomRightRadius", "liBorderBottomLeftRadius"],
          false
        )
      }
    },
    liPaddingTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("liPaddingTypeFlag")) {
          if (((this.liPaddingTop === this.liPaddingRight) === this.liPaddingLeft) === this.liPaddingBottom) {
            defaultType = 2
          }
        }
        return this.options.liPaddingTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liPaddingTypeFlag", false)
      }
    },
    liPadding: {
      get() {
        return this.options.liPadding || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liPadding", false)
      }
    },
    liPaddingTop: {
      get() {
        return this.options.liPaddingTop || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liPaddingTop", false)
      }
    },
    liPaddingRight: {
      get() {
        return this.options.liPaddingRight || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liPaddingRight", false)
      }
    },
    liPaddingLeft: {
      get() {
        return this.options.liPaddingLeft || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liPaddingLeft", false)
      }
    },
    liPaddingBottom: {
      get() {
        return this.options.liPaddingBottom || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liPaddingBottom", false)
      }
    },
    liOpacity: {
      get() {
        return this.options.hasOwnProperty("liOpacity") ? this.options.liOpacity : 100
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liOpacity", false)
      }
    },
    liBoxShadowColor: {
      get() {
        return this.options.hasOwnProperty("liBoxShadowColor") ? this.options.liBoxShadowColor : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBoxShadowColor", false)
      }
    },
    liBoxShadowH: {
      get() {
        return this.options.hasOwnProperty("liBoxShadowH") ? this.options.liBoxShadowH : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBoxShadowH", false)
      }
    },
    liBoxShadowV: {
      get() {
        return this.options.hasOwnProperty("liBoxShadowV") ? this.options.liBoxShadowV : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBoxShadowV", false)
      }
    },
    liBoxShadowBlur: {
      get() {
        return this.options.hasOwnProperty("liBoxShadowBlur") ? this.options.liBoxShadowBlur : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBoxShadowBlur", false)
      }
    },
    liBoxShadowSpread: {
      get() {
        return this.options.hasOwnProperty("liBoxShadowSpread") ? this.options.liBoxShadowSpread : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBoxShadowSpread", false)
      }
    },
    liActiveFontFamily: {
      get() {
        return this.options.liActiveFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveFontFamily", false)
      }
    },
    liActiveFontSize: {
      get() {
        return this.options.liActiveFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveFontSize", false)
      }
    },
    liActiveFontWeight: {
      get() {
        return this.options.liActiveFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveFontWeight", false)
      }
    },
    liActiveFontStyle: {
      get() {
        return this.options.liActiveFontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveFontStyle", false)
      }
    },
    liActiveTextDecoration: {
      get() {
        return this.options.liActiveTextDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveTextDecoration", false)
      }
    },
    liActiveLineHeight: {
      get() {
        return this.options.liActiveLineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveLineHeight", false)
      }
    },
    liActiveLetterSpacing: {
      get() {
        return this.options.liActiveLetterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(`${newVal}`, "liActiveLetterSpacing", false)
      }
    },
    liActiveActiveArrangement() {
      return this.options.liActiveTextAlign
    },
    liActiveWritingMode: {
      get() {
        return this.options.liActiveWritingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveWritingMode", false)
      }
    },
    liActiveTextAlign: {
      get() {
        return this.options.liActiveTextAlign
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveTextAlign", false)
      }
    },
    liActiveActiveArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.liActiveWritingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "liActiveWritingMode", false)
      }
    },
    liActiveLineHeightType: {
      get() {
        return this.options.liActiveLineHeightType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveLineHeightType", false)
      }
    },
    liActiveLetterSpacingType: {
      get() {
        return this.options.liActiveLetterSpacingType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveLetterSpacingType", false)
      }
    },
    liActiveTextIsThemeColor: {
      get() {
        return this.options.liActiveTextIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveTextIsThemeColor", false)
      }
    },
    liActiveFontColor: {
      get() {
        return this.options.liActiveFontColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveFontColor", false)
      }
    },
    liActiveBgColor: {
      get() {
        let background = this.options.liActiveBgColor
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.liActiveBgColor
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.bgColorIsThemeColor,
            color: this.options.bgColor.color ? this.options.bgColor.color : this.options.bgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "liActiveBgColor", false, false, false, true)
        return newBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBgColor", false)
      }
    },
    liActiveShowBorder: {
      get() {
        let liActiveShowBorder = false
        if (this.options.liActiveShowBorder === undefined) {
          if (Array.isArray(this.options.liActiveBorderWidth)) {
            let allZero = true
            for (let i = 0; i < this.options.liActiveBorderWidth.length; i++) {
              if (this.options.liActiveBorderWidth[i] !== 0) {
                allZero = false
              }
            }
            if (allZero) {
              liActiveShowBorder = false
            } else {
              liActiveShowBorder = true
            }
          } else {
            if (this.options.liActiveBorderWidth) {
              liActiveShowBorder = true
            } else {
              liActiveShowBorder = false
            }
          }
          this.$changeOptionsEV(liActiveShowBorder, "liActiveShowBorder", false)
        } else {
          liActiveShowBorder = this.options.liActiveShowBorder
        }
        return liActiveShowBorder
      },
      set(newVal) {
        if (newVal && !this.liActiveBorderWidth) {
          this.$changeOptionsEV([1, newVal], ["liActiveBorderWidth", "liActiveShowBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "liActiveShowBorder", false)
        }
      }
    },
    liActiveBorderWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liActiveBorderWidth", "liActiveBorderWidth", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBorderWidth", false)
      }
    },
    liActiveBorderStyle: {
      get() {
        return this.options.liActiveBorderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBorderStyle", false)
      }
    },
    liActiveBorderColor: {
      get() {
        return this.options.liActiveBorderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBorderColor", false)
      }
    },
    liActiveBorderIsThemeColor: {
      get() {
        return this.options.liActiveBorderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBorderIsThemeColor", false)
      }
    },
    liActiveBorderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("liActiveBorderTypeFlag")) {
          if (
            ((this.liActiveBorderTopLeftRadius === this.liActiveBorderTopRightRadius) ===
              this.liActiveBorderBottomLeftRadius) ===
            this.liActiveBorderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        return this.options.liActiveBorderTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBorderTypeFlag", false)
      }
    },
    liActiveBorderTopLeftRadius: {
      get() {
        return this.options.liActiveBorderTopLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBorderTopLeftRadius", false)
      }
    },
    liActiveBorderTopRightRadius: {
      get() {
        return this.options.liActiveBorderTopRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBorderTopRightRadius", false)
      }
    },
    liActiveBorderBottomRightRadius: {
      get() {
        return this.options.liActiveBorderBottomRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBorderBottomRightRadius", false)
      }
    },
    liActiveBorderBottomLeftRadius: {
      get() {
        return this.options.liActiveBorderBottomLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBorderBottomLeftRadius", false)
      }
    },
    liActiveBorderRadius: {
      get() {
        return this.options.liActiveBorderBottomLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal],
          [
            "liActiveBorderTopLeftRadius",
            "liActiveBorderTopRightRadius",
            "liActiveBorderBottomRightRadius",
            "liActiveBorderBottomLeftRadius"
          ],
          false
        )
      }
    },
    liHoverFontFamily: {
      get() {
        return this.options.liHoverFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverFontFamily", false)
      }
    },
    liHoverFontSize: {
      get() {
        return this.options.liHoverFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverFontSize", false)
      }
    },
    liHoverFontWeight: {
      get() {
        return this.options.liHoverFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverFontWeight", false)
      }
    },
    liHoverFontStyle: {
      get() {
        return this.options.liHoverFontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverFontStyle", false)
      }
    },
    liHoverTextDecoration: {
      get() {
        return this.options.liHoverTextDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverTextDecoration", false)
      }
    },
    liHoverLineHeight: {
      get() {
        return this.options.liHoverLineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverLineHeight", false)
      }
    },
    liHoverLetterSpacing: {
      get() {
        return this.options.liHoverLetterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(`${newVal}`, "liHoverLetterSpacing", false)
      }
    },
    liHoverActiveArrangement() {
      return this.options.liHoverTextAlign
    },
    liHoverWritingMode: {
      get() {
        return this.options.liHoverWritingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverWritingMode", false)
      }
    },
    liHoverTextAlign: {
      get() {
        return this.options.liHoverTextAlign
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverTextAlign", false)
      }
    },
    liHoverActiveArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.liHoverWritingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "liHoverWritingMode", false)
      }
    },
    liHoverLineHeightType: {
      get() {
        return this.options.liHoverLineHeightType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverLineHeightType", false)
      }
    },
    liHoverLetterSpacingType: {
      get() {
        return this.options.liHoverLetterSpacingType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverLetterSpacingType", false)
      }
    },
    liHoverTextIsThemeColor: {
      get() {
        return this.options.liHoverTextIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverTextIsThemeColor", false)
      }
    },
    liHoverFontColor: {
      get() {
        return this.options.liHoverFontColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverFontColor", false)
      }
    },
    liHoverBgColor: {
      get() {
        let background = this.options.liHoverBgColor
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.liHoverBgColor
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.bgColorIsThemeColor,
            color: this.options.bgColor.color ? this.options.bgColor.color : this.options.bgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "liHoverBgColor", false, false, false, true)
        return newBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverBgColor", false)
      }
    },
    liHoverShowBorder: {
      get() {
        let liHoverShowBorder = false
        if (this.options.liHoverShowBorder === undefined) {
          if (Array.isArray(this.options.liHoverBorderWidth)) {
            let allZero = true
            for (let i = 0; i < this.options.liHoverBorderWidth.length; i++) {
              if (this.options.liHoverBorderWidth[i] !== 0) {
                allZero = false
              }
            }
            if (allZero) {
              liHoverShowBorder = false
            } else {
              liHoverShowBorder = true
            }
          } else {
            if (this.options.liHoverBorderWidth) {
              liHoverShowBorder = true
            } else {
              liHoverShowBorder = false
            }
          }
          this.$changeOptionsEV(liHoverShowBorder, "liHoverShowBorder", false)
        } else {
          liHoverShowBorder = this.options.liHoverShowBorder
        }
        return liHoverShowBorder
      },
      set(newVal) {
        if (newVal && !this.liHoverBorderWidth) {
          this.$changeOptionsEV([1, newVal], ["liHoverBorderWidth", "liHoverShowBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "liHoverShowBorder", false)
        }
      }
    },
    liHoverBorderWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liHoverBorderWidth", "liHoverBorderWidth", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverBorderWidth", false)
      }
    },
    liHoverBorderStyle: {
      get() {
        return this.options.liHoverBorderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverBorderStyle", false)
      }
    },
    liHoverBorderColor: {
      get() {
        return this.options.liHoverBorderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverBorderColor", false)
      }
    },
    liHoverBorderIsThemeColor: {
      get() {
        return this.options.liHoverBorderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverBorderIsThemeColor", false)
      }
    },
    liHoverBorderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("liHoverBorderTypeFlag")) {
          if (
            ((this.liHoverBorderTopLeftRadius === this.liHoverBorderTopRightRadius) ===
              this.liHoverBorderBottomLeftRadius) ===
            this.liHoverBorderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        return this.options.liHoverBorderTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverBorderTypeFlag", false)
      }
    },
    liHoverBorderTopLeftRadius: {
      get() {
        return this.options.liHoverBorderTopLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverBorderTopLeftRadius", false)
      }
    },
    liHoverBorderTopRightRadius: {
      get() {
        return this.options.liHoverBorderTopRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverBorderTopRightRadius", false)
      }
    },
    liHoverBorderBottomRightRadius: {
      get() {
        return this.options.liHoverBorderBottomRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverBorderBottomRightRadius", false)
      }
    },
    liHoverBorderBottomLeftRadius: {
      get() {
        return this.options.liHoverBorderBottomLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverBorderBottomLeftRadius", false)
      }
    },
    liHoverBorderRadius: {
      get() {
        return this.options.liHoverBorderBottomLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal],
          [
            "liHoverBorderTopLeftRadius",
            "liHoverBorderTopRightRadius",
            "liHoverBorderBottomRightRadius",
            "liHoverBorderBottomLeftRadius"
          ],
          false
        )
      }
    },
    noteEditorAnchor: {
      get() {
        return this.options.noteEditorAnchor || false
      },
      set(newVal) {
        historyCombineWrap(() => {
          this.$changeOptionsEV(newVal, "noteEditorAnchor", false)
          this.changeAnchorType(newVal ? 2 : 1)
        })()
      }
    },
    fullScrollAnchor: {
      get() {
        return this.options.fullScrollAnchor || false
      },
      set(newVal) {
        historyCombineWrap(() => {
          this.$changeOptionsEV(newVal, "fullScrollAnchor", false)
          this.changeAnchorType(newVal ? 3 : 1)
        })()
      }
    },
    anchorList: {
      get() {
        return this.options.anchorList
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "anchorList", false)
      }
    },
    pageEnableFullScroll() {
      return this.$store.state[this.request_prefix].page.enableFullScroll
    }
  },
  mounted() {
    this.changeSubItem(0, false)
  },
  methods: {
    addBoxshadow(prefix) {
      if (!Array.isArray(this[`${prefix}oxShadowH`])) {
        this[`${prefix}oxShadowH`] = [this[`${prefix}oxShadowH`]]
        this[`${prefix}oxShadowV`] = [this[`${prefix}oxShadowV`]]
        this[`${prefix}oxShadowBlur`] = [this[`${prefix}oxShadowBlur`]]
        this[`${prefix}oxShadowSpread`] = [this[`${prefix}oxShadowSpread`]]
        this[`${prefix}oxShadowColor`] = [this[`${prefix}oxShadowColor`]]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this[`${prefix}oxShadowH`]))
      let boxShadowV = JSON.parse(JSON.stringify(this[`${prefix}oxShadowV`]))
      let boxShadowBlur = JSON.parse(JSON.stringify(this[`${prefix}oxShadowBlur`]))
      let boxShadowSpread = JSON.parse(JSON.stringify(this[`${prefix}oxShadowSpread`]))
      let boxShadowColor = JSON.parse(JSON.stringify(this[`${prefix}oxShadowColor`]))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this[`${prefix}oxShadowH`] = boxShadowH
      this[`${prefix}oxShadowV`] = boxShadowV
      this[`${prefix}oxShadowBlur`] = boxShadowBlur
      this[`${prefix}oxShadowSpread`] = boxShadowSpread
      this[`${prefix}oxShadowColor`] = boxShadowColor
    },
    changeSubItem(val, flag) {
      this.curSub = val
      this.$emit("update:statusOpened", flag)
      this.$emit("update:styleOpened", !flag)
      this.$emit("onHideHeader", flag)
      if (val === 1) {
        this.$eventBus.$emit("enableOpen", this.ids)
      }
    },
    changeAnchorType(val) {
      if (val === 1) {
        this.initNormalMenu()
      } else if (val === 2) {
        this.initMultiEditorMenu()
      } else {
        this.initFullScrollMenu()
      }
    },
    initMultiEditorMenu() {
      const list = []
      let multieditor = document.querySelectorAll(".multieditor h1, .multieditor h2, .multieditor h3, .multieditor h4")
      if (multieditor.length > 0) {
        for (let i = 0; i < multieditor.length; i++) {
          let curDom = multieditor[i]
          list.push({
            tagName: curDom.tagName,
            target: curDom.getAttribute("element-id"),
            content: curDom.innerText,
            hide: false
          })
        }
      }
      this.anchorList = this.convertToTree(list)
    },
    convertToTree(arr) {
      const root = {
        children: []
      }
      const stack = [root]
      arr.forEach(item => {
        const level = parseInt(item.tagName.substring(1))
        const node = {
          ...item,
          children: []
        }
        // 如果当前节点的层级小于等于栈顶节点的层级
        // 则需要回溯到合适的父节点
        while (stack.length > 1 && parseInt(stack[stack.length - 1].tagName?.substring(1) || 0) >= level) {
          stack.pop()
        }
        stack[stack.length - 1].children.push(node)
        stack.push(node)
      })
      return root.children
    },
    initNormalMenu() {
      this.anchorList = [
        { content: "锚点1", target: null, hide: false, children: [] },
        { content: "锚点2", target: null, hide: false, children: [] },
        { content: "锚点3", target: null, hide: false, children: [] }
      ]
    },
    initFullScrollMenu() {
      const pageLayoutList = this.$store.state[this.request_prefix].page.pageLayoutList
      const pageAnchor = pageLayoutList.find(item => item.options.inDocument === "anchor" && item.options.isShow)
      if (!pageAnchor) {
        this.anchorList = []
        return
      }
      if (pageAnchor.options.isNewAnchor) {
        this.anchorList = pageAnchor.options.anchorData
          .filter(item => item.fullSwitchType === "toAssignedPage" && item.anchorShow)
          .map(item => ({
            content: item.content,
            target: item.fullSwitchPage,
            switchType: item.fullSwitchType,
            hide: false,
            children: []
          }))
      }
    }
  }
})
</script>
